export default {
  domainDirectory: {
    title: "Dominios oficiales", subtitle: "Verifica aquí las direcciones oficiales. Toca para copiar.", available: " accesibles",
    loading: "Cargando dominios…", loadFailed: "No se pudieron cargar los dominios", retry: "Recargar", empty: "No hay dominios activos",
    tapToCopy: "Toca para copiar", checking: "Comprobando", checkingShort: "Probando", online: "Accesible", offline: "Tiempo de conexión agotado",
    waiting: "En espera", timeout: "Tiempo agotado", testAll: "Probar todos los dominios", updatedEveryFifteenSeconds: "La conexión se comprueba automáticamente cada 15 segundos",
    saveReminder: "Haz una captura de esta página para conservar los datos de los dominios", copied: "Dominio copiado",
    names: { primary: "Dominio principal", chinaAccel: "Aceleración en China", secondary: "Dominio secundario" },
  },
  nickname: {"edit": "Editar apodo", "hint": "2–20 letras chinas/inglesas, dígitos o _", "saved": "Apodo guardado", "taken": "Este apodo ya está en uso", "invalid": "Usa 2–20 letras chinas/inglesas, dígitos o _. No se permiten nombres reservados.", "failed": "No se pudo guardar. Inténtalo de nuevo."},
  common: {
    confirm: "Confirmar",
    cancel: "Cancelar",
    search: "Buscar",
    language: "Idioma",
    pleaseRelogin: "Sesión expirada, inicia sesión de nuevo",
    developing: "Función en desarrollo",
    switched: "Cambiado",
    currentLanguage: "Idioma actual",
    selectLanguage: "Seleccionar idioma",
    loading: "Cargando...",
    loadingMore: "Cargando más...",
    noMoreData: "No hay más datos",
    noData: "Sin datos",
    serverUnavailable: "Servidor temporalmente no disponible",
    loadFailed: "Error al cargar",
    requestFailed: "Error de solicitud",
    retry: "Toca para reintentar",
    projectName: "PANTA MARKET",
    duplicateSubmission: "Por favor, no envíe de nuevo",
    fee: "Tarifa",
    submit: "Enviar",
    tip: "Aviso",
    connecting: "Conectando...",
    connectWalletFirst: "Conecta tu billetera primero",
    connect: "Conectar",
    insufficientBalance: "Saldo insuficiente",
    copyFailed: "Error al copiar",
    sessionAuthRelogin: "Iniciar sesión de nuevo",
    sessionAuthStay: "Permanecer",
    pager: {
      prevPage: "Anterior",
      nextPage: "Siguiente",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Ir a",
      jumpConfirm: "Ir",
    },
  },
  tabbar: {
    home: "Home",
    market: "Timeline",
    timeline: "Timeline",
    prediction: "Predicción de contrato de eventos AI",
    createMarket: "Crear mercado",
    planet: "Planet",
    trade: "AI Prediction",
    finance: "Finance",
    fund: "Fondo",
    assets: "Assets",
    planethistory: "History"
  },
  tradeMenu: {
    contract: "Event Contract",
    insurance: "Insurance",
    spot: "Spot",
    flash: "Flash Swap"
  },
  home: {
    searchPlaceholder: "BTC",
    bannerTitle: "PANTA MARKET",
    bannerSubtitle: "Predicción IA · Contratos de evento · Análisis inteligente",
    predictionCategories: {
      hot: "Timeline",
      sports: "Sports",
      world: "World",
      politics: "Politics",
      economy: "Economy"
    },
    predictionSubCategories: {
      crypto: "Spot",
      forex: "Forex",
      commodities: "Commodities"
    },
    features: {
      recharge: "Recharge",
      rechargeDesc: "Quick deposit",
      contract: "Event Contract",
      contractDesc: "Innovative financial tools",
      predict: "AI Prediction",
      fund: "PANTA MARKET Treasury",
      invite: "Invite Friends",
      global: "Global Nodes"
    },
    insurance: {
      title: "Contract Insurance Pool (TAKER)",
      aiPoolTitle: "Pool de seguro AI",
      ordinaryPoolTitle: "Pool de valor de seguro ordinario",
      approxUsdt: "≈ {amount} U",
      approxPantaRef: "≈ {amount} PANTA (ref.)",
      more: "Learn More",
      yesterday: "Added Yesterday",
      service: "Smart Service"
    },
    market: {
      tabs: {
        main: "Main",
        hot: "Hot",
        rise: "Gainers",
        price: "Price"
      },
      headers: {
        pair: "Pair",
        latest: "Latest Price",
        change: "24h Change"
      },
      viewMore: "View More",
      collapse: "Collapse"
    },
    announcement: {
      title: "Anuncio",
      heading: "Anuncio",
      text: "Welcome to PANTA MARKET. Explore event contracts, AI insights, and protection tools for prediction markets. Here, you will experience the unique AI and prediction insurance system created by PANTA MARKET, allowing you to easily join the WEB3 prediction market and start your journey to wealth.",
      time: "2025/11/19 10:00",
      gotIt: "Entendido",
      viewDetail: "Ver detalles",
      systemLabel: "Anuncio del sistema"
    },
    timePeriods: {
      "1min": "1 Minuto",
      "30min": "30 Minutos",
      "1hour": "1 Hora"
    },
    footer: {
      australia: "· Australia",
      uae: "· United Arab Emirates",
      attention: "· ATTENTION:",
      attentionText: "PANTA MARKET is operated by the platform itself. We do not authorize any third party to collect fees in our name. We do not authorize any third party to collect fees in any form or name. For inquiries, please contact official customer service at: {email}"
    },
    timeframes: {
      "1s": "1 min",
      "1m": "1 min",
      "5m": "5 min",
      "15m": "15 min",
      "1h": "1 hora",
      "4h": "4 horas",
      "1d": "1 día"
    },
    statusHotEn: "HOT",
    yes: "Sí",
    no: "No",
    hotBannerTitle: "Contrato de evento",
    homeBanner: {
      s1t1: "Con IA",
      s1t2: "Ecosistema central AstralX",
      s1cta: "AstralX",
      s2t: "Fondo Galaxy",
      s2s1: "Conoce la protección de capital",
      s2s2: "y las reglas de pago",
      s2cta: "Suscribirse",
      s3s: "Predicción de precio",
      s3cta: "Predecir",
    },
    catCrypto: "Cripto",
    catMetal: "Metales",
    catSports: "Deportes",
    catPolitics: "Política",
    catEntertainment: "Entretenimiento",
    statusHot: "Popular",
    statusLocked: "Bloqueado",
    statusLive: "En vivo",
    statusLockedWait: "Bloqueado, pendiente de liquidación",
    jouleUnit: "JOULE",
    nowLabel: "Ahora",
    endAtFallback: "--",
    predictionLabel: "Prediction",
    rise: "Up",
    fall: "Down",
    viewMoreOptions: "Ver {n} opciones más",
    categoryAll: "Todo",
    categoryCrypto: "Cripto",
    categoryEquity: "Acciones",
    categoryCommodity: "Materias primas",
    categoryForex: "Forex",
    categoryMetal: "Metales"
  },
  withdraw: {
    title: "Retirar",
    headerTitle: "Withdraw",
    address: "Dirección de Retiro",
    addressLabel: "Withdrawal Address",
    addressPlaceholder: "Enter or paste address",
    network: "Red",
    selectNetwork: "Seleccionar Red",
    networkHint: "Asegúrese de que la dirección de retiro coincida con la red seleccionada",
    withdrawAmount: "Cantidad de Retiro",
    receiveAmount: "Cantidad a Recibir",
    networkFee: "Tarifa de Red",
    submit: "Confirmar Retiro",
    submitButton: "Retirar",
    balance: "Balance",
    all: "All",
    amountPlaceholder: "Please enter",
    minimumWithdrawal: "Minimum withdrawal amount: {amount} USDT",
    minimumWithdrawalTAKER: "Minimum withdrawal amount: {amount}TAKER",
    fee: "Fee",
    confirm: "Confirm",
    confirmTitle: "Confirm Action",
    confirmContent: "Are you sure you want to proceed?",
    toasts: {
      fetchFailed: "Failed to fetch assets",
      enterAddress: "Please enter a withdrawal address",
      enterValidAmount: "Please enter a valid withdrawal amount",
      insufficientBalance: "Insufficient balance",
      minimumAmount: "Minimum withdrawal amount is {amount} USDT",
      processing: "Processing...",
      success: "Retiro exitoso!",
      requestSuccess: "Withdrawal request successful",
      requestFailed: "Withdrawal failed, please try again",
      notConfigured: "Withdrawals are not available yet"
    },
    addressHint: "Withdrawal will be sent to your wallet address"
  },
  deposit: {
    headerTitle: "Deposit",
    qrTitle: "Deposit USDT",
    addressLabel: "Deposit To",
    addressCopied: "Address copied successfully",
    connectPrompt: "Please connect your wallet to deposit",
    loading: "Loading...",
    depositAddress: "Deposit Address",
    minimumDeposit: "*Minimum deposit 10.0000 USDT",
    depositAmount: "Deposit Amount",
    balance: "Balance",
    amaBalance: "JOULE Balance",
    amount: "Amount",
    amountPlaceholder: "Enter deposit amount",
    minimumNotice: "*Minimum {min} {token}",
    processing: "Processing...",
    confirm: "Confirm Deposit",
    confirmTitle: "Confirm Action",
    confirmContent: "Are you sure you want to proceed?",
    helpText: "Deposit will call the smart contract recharge method, TAKER token approval required",
    depositNotice: "Please transfer to the following address, the system will process automatically after arrival",
    toasts: {
      copySuccess: "Copied successfully",
      dataLoadFailed: "Failed to load data",
      enterValidAmount: "Please enter a valid deposit amount",
      invalidAmount: "Deposit amount cannot be less than {min} TAKER",
      invalidAddress: "Invalid deposit address",
      checkingAllowance: "Checking allowance...",
      approving: "Approving...",
      approveSuccess: "Approval successful",
      depositing: "Depositing...",
      depositSuccess: "Deposit successful",
      depositFailed: "Deposit failed",
      balanceLoadFailed: "No se pudo leer el saldo de USDT de prueba. Actualiza e inténtalo de nuevo",
      contractError: "Contract call failed, please check balance",
      userCancelled: "You have cancelled the operation",
      insufficientFunds: "Saldo insuficiente",
      wrongNetwork: "Please switch to the correct network",
      requestingAuth: "Requesting wallet authorization...",
      waitingConfirmation: "Waiting for transaction confirmation...",
      transactionFailed: "Transaction initiation failed",
      transactionCancelled: "You have cancelled the transaction",
      genericError: "Transaction failed",
      gettingPaymentInfo: "Getting payment info...",
      cannotGetBalance: "Cannot get balance, please refresh and try again",
      configNotReady: "Deposits are not available yet",
      invalidTxHash: "Please enter a valid transaction hash",
      claimPending: "Deposit submitted, credit pending"
    },
    usdtBalance: "USDT Balance"
  },
  team: {
    headerTitle: "My Team",
    contractEarnings: "My Contract Earnings",
    btcFund: "Rendimiento financiero",
    stats: {
      teamSubscribed: "Stake del equipo",
      personalSubscribed: "Stake personal",
      totalTeam: "Volumen del equipo",
      periodTeam: "Ganancias del equipo",
      periodPersonal: "Volumen personal",
      personalEarnings: "Ganancias personales acumuladas",
      teamEarnings: "Ganancias del equipo",
      personalVolume: "Volumen personal",
      teamVolume: "Volumen del equipo",
      personalPower: "Personal Power",
      teamTotalPower: "Team Total Power"
    },
    links: {
      invite: "Invite Friends",
      details: "Team Details"
    },
    inviteBannerTitle: "Invite Friends to Unlock Team Commissions",
    inviteBannerSubtitle: "Unlock your team commissions",
    inviteBannerCta: "Join Now",
    unclassifiedHint: "Origen histórico de pago por revisar: {amount} {asset}"
  },
  my: {
    headerTitle: "My",
    login: "Tap to Login",
    inviteCode: "Invite Code:",
    groups: {
      common: "Common Features",
      trading: "Trading",
      finance: "Finance",
      help: "Help"
    },
    features: {
      invite: "Invite Friends",
      team: "My Team",
      insurance: "Event Contract Insurance",
      contract: "Event Contract",
      exchange: "Exchange",
      fund: "AI Treasury Fund",
      communitySquare: "Plaza comunitaria",
      createEvent: "Crear evento",
      community: "Official Community",
      terms: "Terms of Service",
      announcement: "Anuncios",
      privacy: "Privacy Policy",
      aboutUs: "Sobre nosotros"
    }
  },
  community: {
    title: "Comunidad Oficial",
    bannerTitle1: "Únete a Nuestra Comunidad",
    bannerTitle2: "Conéctate con Usuarios Globales",
    linkCopied: "Enlace Copiado"
  },
  invite: {
    headerTitle: "Invite Friends",
    rulesEntry: "Invite Rules",
    subtitle: "Earn from every team trade",
    mainTitle: "Invite & Earn",
    description: "Share the link — friends trade, you get rewards",
    yourCode: "Your Invite Code",
    shareLink: "Share Link",
    inviteButton: "Invite Friends",
    subTitle: "Get High Commissions",
    viewRules: "View Rules",
    rulesLink: "View Referral Rules >",
    rulesTitle: "Referral Rules",
    rules: {
      commissionTable: {
        title: "PANTA MARKET Trading Volume Commission Table",
        headers: {
          level: "Level",
          personalTurnover: "Personal Vol",
          teamTurnover: "Team Vol",
          commission: "Team Comm"
        }
      }
    },
    inviteBoxTitle: "Invite Friends",
    referralCode: "Referral Code",
    inviteLink: "Invitation Link",
    loading: "Loading...",
    copyButton: "Copy Invitation Link",
    toasts: {
      emptyContent: "Content is empty",
      copySuccess: "Copied successfully",
      bindSuccess: "Vinculación exitosa",
      bindFailed: "Vinculación fallida",
      alreadyBound: "Superior ya vinculado; no se puede cambiar",
      loginFirst: "Conecta la cartera primero",
      invalidCode: "Introduce un código de invitación o dirección válidos",
      cannotBindSelf: "No puedes vincularte a ti mismo",
    },
    boundLabel: "Superior vinculado",
    modalDesc: "Aún no has vinculado un superior. Introduce el código o la dirección de la cartera para unirte a las recompensas del equipo. El enlace se rellena solo; si no hay invitación, se precarga el superior por defecto.",
    bindPlaceholder: "Introduce el código o la dirección de la cartera",
    bindButton: "Vincular",
    binding: "Vinculando…",
    bindSuperior: "Vincular superior",
  },
  finance: {
    title: "Finance page is under development..."
  },
  wealthAccess: {
    exchangeThresholdFailed: "Error de cambio: no se cumplen los requisitos",
    internalPrice: "Precio interno",
    marketPrice: "Precio de mercado",
    coinBasis: "Basado en moneda",
    legacyBasis: "Basado en moneda",
    contractBasis: "Base de liquidación",
    unitPrice: "Precio unitario de compra",
    quotaUsed: "Compras internas acumuladas",
    quotaRemaining: "Cupo interno restante",
    quotaHint: "Límite vitalicio de {limit} PANTA entre todos los planes. Desactivar, vencer o cambiar VIP no reinicia el total.",
    principal: "Capital",
    principalReturn: "Capital devuelto al vencimiento",
    dailyYield: "Rendimiento bruto diario",
    coinYieldHint: "Rendimiento diario = capital PANTA × tasa anual ÷ 360, truncado en unidades atómicas. El precio no cambia las monedas del contrato. Distribución según las reglas aplicables.",
    legacyHint: "Contrato basado en moneda. El capital en PANTA se convierte al precio contractual de vencimiento.",
    quotaError: "Cupo interno excedido. Reduce la cantidad; no se divide ni se cambia al precio de mercado automáticamente.",
    permissionChanged: "Plan no disponible para tu VIP actual. Lista actualizada.",
    quoteChanged: "Cambió el precio o la elegibilidad. Revisa la nueva cotización y confirma de nuevo.",
    quoteExpired: "Cotización vencida. Actualiza y revisa antes de confirmar.",
    retryQuote: "Actualizar cotización",
    stakeGateTitle: "Staking requerido para vender PANTA",
    stakeGateBody: "VIP{vip}: staking activo {staked} PANTA; requerido {required} PANTA; faltan {shortfall} PANTA. Solo se restringe la venta, no la compra.",
    goStake: "Ir a staking",
    refreshEligibility: "Actualizar elegibilidad",
  },
  fundPage: {
    heroTitle: "Rendimientos PANTA repartidos a diario",
    heroDesc: "Suscríbete al fondo Galaxy y obtén dividendos anualizados",
    learnMore: "Más información",
    allProducts: "Todos los productos",
    subscribe: "Suscribirse",
    stake: "Stake",
    stakePreview: "Vista previa del stake",
    searchCoin: "Buscar moneda",
    allPeriods: "Todos los plazos",
    colCoin: "Nombre del fondo",
    colApy: "APY en token",
    colTerm: "Plazo",
    fixedTerm: "Plazo fijo",
    galaxyProduct: "Galaxy {n}",
    termLabel: "Plazo",
    apyLabel: "APY",
    stakeCap: "Tenencias personales",
    stakeAmount: "Importe del stake",
    estEarnings: "Ganancia estimada",
    stakeDisclaimer: "El rendimiento es ilustrativo y no está garantizado. Aprox. el 70% va al saldo disponible y el 30% a fondos de prueba; los fondos de prueba se desbloquean tras ~3x de volumen.",
    stakeSuccess: "Stake realizado",
    annualized: "APY de referencia",
    perShareYield: "Rendimiento / 10 mil (WBS)",
    dayUnit: "d",
    empty: "Aún no hay productos de fondo",
    loadFailed: "Error al cargar",
    rulesTitle: "Información del fondo",
    gotIt: "Entendido",
    pantaAvailable: "PANTA disponible",
    activeFaceValue: "Participaciones activas",
    totalReward: "Rendimiento acumulado del fondo (PANTA)",
    fundYieldUnavailable: "--/Actualice el servicio",
    effectiveVip: "Nivel efectivo",
    myHoldings: "Historial de compra del fondo",
    faceValue: "Valor",
    maturity: "Vencimiento",
    stakeStart: "Hora del stake",
    pantaPrice: "Precio PANTA",
    noMoreHoldings: "No hay más posiciones",
    subscriptionStatus: {
      ACTIVE: "Activo",
      SETTLED: "Liquidado",
      CANCELLED: "Cancelado",
      MANUAL_REVIEW: "Revisión manual",
    },
    minPanta: "Mín. PANTA",
    pantaAmount: "Cantidad de suscripción (PANTA)",
    stepHint: "Múltiplo de {step}, mín. {min}",
    getQuote: "Obtener cotización",
    confirmStake: "Confirmar stake",
    jouleDebit: "Débito de JOULE",
    expectedPanta: "PANTA en stake",
    quoteExpires: "Cotización válida hasta",
    unavailable: "No disponible",
    invalidAmount: "Introduce una cantidad PANTA válida según el paso",
    quoteFailed: "Error de cotización",
    rewards: "Recompensas del fondo",
    unlock: "Lotes de congelación PANTA",
    unlockProgress: "Volumen de trading usado",
    pantaLedger: "Libro PANTA"
  },
  finanfund: {
    title: "PANTA MARKET Treasury Fund",
    subtitle: "Simple, Efficient, Easy Earnings",
    productName: "PANTA MARKET Treasury Fund",
    minAmount: "Min Amount",
    incomeRatio: "Income Ratio",
    lockPeriod: "Lock Period",
    dailyReturn: "Daily Return",
    earning: "Earned",
    redemptionRules: "Redemption Rules",
    rules: {
      rule1: "PANTA MARKET Treasury Fund cannot be redeemed after custody",
      rule2: "Daily earnings are automatically credited",
      rule3: "Locked amount will be returned after the lock period ends"
    },
    subscription: "Subscribe",
    amountPlaceholder: "Enter amount",
    balance: "Balance",
    availableFunds: "Available Funds",
    all: "All",
    subscribeButton: "Subscribe",
    toasts: {
      productIdNotExist: "Product ID does not exist",
      enterValidAmount: "Please enter a valid subscription amount",
      minAmountRequired: "Subscription amount cannot be less than {amount} USDT",
      subscribeSuccess: "Subscription successful",
      subscribeFailed: "Subscription failed"
    }
  },
  assets: {
    insuranceFrozen: "Monto congelado del seguro (JOULE)",
    available: "Available",
    deposit: "Deposit",
    withdraw: "Withdraw",
    myAccountRecords: "My Account Records",
    nodeEquityHint: "Node equity valued in USDT, not a cash deposit",
    nodeEquityRate: "Applied rate: {rate}%",
    nodeEquitySources: {
      PERSONAL: "Personal insurance equity",
      TEAM: "Team insurance equity",
      ADMIN: "Platform Airdrop",
      AI_INSURANCE: "AI insurance node equity payout",
      BACKFILL: "AI insurance node equity backfill",
      OTHER: "Node equity credited",
    },
    recordTypes: {
      NODE_EQUITY_CREDIT: "Node equity credited",
      BET_STAKE: "Congelación de apuesta",
      WIN_PAYOUT: "Ganancia de trading",
      LOSS_SETTLEMENT: "Pérdida de trading",
      REFUND: "Reembolso",
      INSURANCE_PREMIUM: "Gasto de prima",
      INSURANCE_PAYOUT: "Indemnización del seguro",
      INSURANCE_TRANSFER_IN: "Transferencia de entrada del seguro",
      INSURANCE_TRANSFER_OUT: "Transferencia de salida del seguro",
      NETWORK_DIFFERENTIAL: "Premio diferencial de trading",
      NETWORK_PEER: "Premio de mismo nivel",
      NETWORK_UNLOCK: "Desbloqueo de ganancias",
      EVENT_INSURANCE_PAYOUT: "Pago de nodo de cómputo",
      EVENT_INSURANCE_PEER: "Premio de mismo nivel de cómputo",
      TRANSFER_IN: "Entrada",
      TRANSFER_OUT: "Salida",
      PREMIUM_LOCK: "Bloqueo de prima",
      PREMIUM_SETTLE: "Gasto de prima",
      PREMIUM_REFUND: "Reembolso de prima",
      WEALTH_SUBSCRIPTION: "Suscripción del fondo",
      SUBSCRIPTION_LOCK: "Bloqueo de staking",
      WEALTH_DAILY_REWARD: "Interés diario del fondo",
      WEALTH_TEAM_REWARD: "Premio de equipo del fondo",
      MATURITY_RELEASE: "Devolución del principal al vencimiento",
      WEALTH_UNLOCK: "Desbloqueo de ganancias",
      COPY_SHARE_HOLD: "Copy share held",
      COPY_SHARE_RELEASE: "Copy share unfrozen / refunded",
      COPY_SHARE_PAYOUT: "Copy share paid out",
      COPY_TRADE_TRANSFER_OUT: "Transfer to copy account",
      COPY_TRADE_TRANSFER_IN: "Transfer from copy account",
      COPY_WIN_PAYOUT: "Copy profit",
      COPY_LOSS_SETTLEMENT: "Copy loss",
      COPY_TRANSFER_IN: "Deposit to copy account",
      COPY_TRANSFER_OUT: "Withdraw from copy account",
      COPY_SHARE_PAYOUT_IN: "Copy share received",
      COPY_SHARE_POOL_IN: "Copy share pool in",
      COPY_SHARE_POOL_REFUND: "Copy share pool refund",
      COPY_SHARE_POOL_MIGRATION: "Copy share pool migration",
      COPY_FLOW: "Copy trade record"
    },
    recordCategories: {
      NODE_EQUITY: "Node equity",
      TRADE_PNL: "P&L de trading",
      PREMIUM: "Prima",
      INSURANCE_PAYOUT: "Indemnización",
      TEAM_REWARD: "Premio de equipo",
      COPY: "Copy Details",
      COPY_TRADE_PNL: "Copy P&L",
      COPY_SHARE: "Copy share",
      COPY_TRANSFER: "Copy transfer",
      WEALTH_REWARD: "Interés del fondo",
      UNLOCK: "Desbloqueo",
      PRINCIPAL: "Suscripción/devolución",
      TRANSFER: "Transferencia interna"
    },
    amountPendingReview: "Importe pendiente de revisión",
    creditedSplit: "Disponible {available} · Congelado {frozen}",
    creditedSplitPending: "Desglose pendiente de revisión",
    afterBalance: "Después: disponible {available} · congelado {frozen}",
    unlockHint: "Congelado → disponible; no es ganancia nueva",
    transferFromInsurance: "Cuenta de seguro",
    transferFromMain: "Cuenta principal",
    all: "All",
    transfer: "Transfer",
    insuranceDeduction: "Insurance Deduction",
    insurancePayout: "Insurance Payout",
    noRecords: "No records",

    actions: {
      deposit: "Deposit",
      withdraw: "Withdraw",
      exchange: "Exchange",
      transfer: "Transfer"
    },
    loginPrompt: {
      text: "Please connect your wallet first",
      button: "Connect"
    },
    toasts: {
      connectFailed: "Connection failed, please try again"
    },
    pantaUsdtRate: "1 PANTA = {price} USDT",
    buyNodeModal: {
      title: "Buy Trading Node",
      cancel: "Cancel Purchase",
      purchasing: "Purchasing...",
      confirm: "Confirm Purchase",
      availableBalance: "Available Balance",
      unavailable: "Not available yet",
      description: "Pay {amount}JOULE to get trading node access",
      insufficient: "Insufficient balance, please deposit first",
      success: "Purchase successful",
      failed: "Purchase failed, please retry"
    },
    transferToMain: "Transfer to Main System",
    mainSystemPanta: "Main System (PANTA)",
    jouleAvailable: "JOULE Available",
    detailTitle: "Asset Details",
    totalAssetsUsdt: "Estimated Total Value (USDT)",
    jouleConvert: "JOULE Converted (× rate)",
    usdtPart: "USDT Portion",
    totalSum: "Total",
    tradeFrozen: "Trade Frozen (JOULE)",
    financeReleaseFrozen: "Finance Release Frozen (JOULE)",
    insuranceAccountJoule: "Insurance (JOULE)",
    usdtAvailableLabel: "USDT Available",
    usdtFrozenLabel: "USDT Frozen",
    noHoldings: "No holdings yet",
    availableAssets: "Available Assets",
    tradeFrozenJoule: "Trade Frozen (JOULE)",
    payoutPower: "Compute Node Payout",
    payoutEquity: "AI Prediction Payout (JOULE)",
    mainAccount: "Trading",
    insuranceAccountShort: "Seguro",
    copyAccountShort: "Copy",
    tradingAccountHelpTitle: "Trading account balance",
    copyAvailableLabel: "Available",
    copyFrozenLabel: "Frozen",
    copyAccountJoule: "Cuenta copy (JOULE)",
    copyTotalPnl: "PnL copy",
    transferSheet: {
      title: "Transferir",
      pairCopy: "Trading / Copy",
      pairInsurance: "Trading / Seguro",
      tradingAccount: "Cuenta de trading",
      copyAccount: "Cuenta de copy",
      insuranceAccount: "Cuenta de seguro",
      jouleHint: "Solo transferencias JOULE",
      submit: "Enviar",
      transferring: "Transfiriendo...",
      success: "Transferencia exitosa",
      failed: "Transferencia fallida, reintente",
    },
    computeNode: "Compute Nodes",
    stakedTotalPanta: "Fund Staked",
    stakedPlusRewardPanta: "Stake + Est. Earnings",
    stakedPlusRewardTipTitle: "Stake principal + estimated earnings",
    stakedPlusRewardTip:
      "Este importe es el principal en stake más las ganancias estimadas.",
    stakedPrincipalLabel: "Principal en stake",
    stakedExpectedYieldLabel: "Ganancias estimadas",
    annualEarningsPanta: "Fund Earnings",
    frozenTotalPanta: "Total Frozen",
    unlockedTotalPanta: "Total Unlocked",
    fundTeamPendingPanta: "Recompensas de equipo pendientes (PANTA)",
    fundTeamPaidPanta: "Recompensas de equipo pagadas (PANTA)",
    pendingRewardPanta: "Pending Airdrop",
    paidRewardPanta: "Airdropped",
    expectedAirdropQuota: "Estimated Pending Airdrop",
    cumulativeAirdropValue: "Valor acumulado de airdrops: {value} USDT",
    roundProgress: "Node Generation Progress",
    currentNodeCount: "Current Nodes",
    roundExpectedValue: "Est. this round: {value} USDT",
    historyTotalValue: "Historical total: {value} USDT",
    nextAirdropAt: "Next distribution: {time}",
    airdropEstimateUnavailable: "Unable to estimate",
    roundExpectedValueUnavailable: "Est. this round: unable to estimate",
    airdropEstimateHint: "Estimate only; actual settlement prevails",
    invalidNodeCount: "Invalid Nodes",
    deductedNodeCount: "Deducted Nodes",
    todayRelease: "Today Release",
    releaseFrozenPanta: "Release Frozen",
    unlockQuota: "Unlock Quota",
    unlockQuotaNote: "Today unlockable 0.0000",
    tradeNode: "Trade Node",
    tradeNodeDesc: "Upgrade to VIP3 and unlock trading benefits",
    tradeNodeHint: "Price: 2888 JOULE · Upgrade to VIP3",
    buyNode: "Buy Node",
    insuranceAccountRecordsShort: "Insurance"
  },
  walletBind: {
    connectWallet: "Conectar",
    inputPlaceholder: "Ingresar dirección",
    bind: "Vincular",
    binding: "Vinculando",
    tip: "Consejo: Si la conexión de la billetera falla, puede intentar ingresar manualmente la dirección de la billetera para vincular"
  },
  loginModal: {
    title: "Iniciar sesión en PANTA MARKET",
    connectWallet: "Conectar",
    connecting: "Conectando...",
    alreadyConnected: "Conectado",
    tip: "Consejo: Si la conexión de la billetera falla, puede intentar ingresar manualmente la dirección de la billetera para vincular",
    inputLabel: "Ingrese la dirección de la billetera",
    inputPlaceholder: "0x234d456f6798...",
    bind: "Vincular",
    binding: "Vinculando",
    bindSuccess: "Vinculación exitosa",
    bindSuccessHint: "Vinculación exitosa, inicie sesión nuevamente",
    bindFailed: "Vinculación fallida",
    noAuthCode: "Código de autorización faltante",
    invalidAddress: "Formato de dirección de billetera no válido",
    confirmTitle: "Confirmar vinculación",
    confirmWarning: "Por favor confirme cuidadosamente que la siguiente dirección es la dirección de su billetera. No se puede cambiar después de vincular",
    addressLabel: "Dirección de billetera",
    cancel: "Cancelar",
    confirm: "Confirmar vinculación",
    loginSuccess: "Inicio de sesión correcto",
    openWalletApp: "Abrir {wallet}",
    openWalletConnect: "Abrir {wallet} para conectar",
    openWalletSign: "Abrir {wallet} para firmar",
    returnToBrowser: "Vuelve aquí cuando termines",
    loginStepLabel: "Paso {step}/2",
    stepConnectTitle: "Conectar billetera",
    stepConnectHint: "Aprueba la conexión en tu billetera y vuelve aquí",
    stepConnectHintWithOpen: "Toca abajo para abrir tu billetera, aprueba la conexión y vuelve aquí",
    stepSignTitle: "Iniciar sesión",
    stepSignHint: "Firma el mensaje de inicio en tu billetera (no mueve fondos) y vuelve aquí",
    stepSignHintWithOpen: "Un paso más: toca abajo para abrir tu billetera y firmar el mensaje",
    waitingWalletHintShort: "Si no se abrió, toca abajo para abrir tu billetera",
    retryLogin: "Reintentar inicio de sesión",
    networkRequired: "Cambiar de red",
    networkRequiredHint: "Cambia a {chain}, vuelve aquí e inténtalo de nuevo",
    switchingNetwork: "Confirmar cambio de red",
    switchingNetworkHint: "Aprueba el cambio a {chain} en tu billetera",
    signatureRequired: "Firma para iniciar sesión",
    signatureHint: "Firma en tu billetera; esto no transfiere fondos",
    verifyingLogin: "Verificando",
    verifyingHint: "Espera un momento",
    connectFailed: "Conexión incompleta, inténtalo de nuevo",

    waitingWalletReturn: "Autoriza en la app de la billetera y vuelve aquí",
    waitingWalletHint: "Autoriza en la billetera; volverás aquí automáticamente"
  },
  walletProfile: {
    title: "Perfil",
    address: "Dirección",
    accountName: "Nombre de Cuenta",
    inviteCode: "Código de Invitación",
    deactivateAccount: "Desactivar Cuenta",
    logout: "Cerrar Sesión",
    switchAccount: "Cambiar Cuenta",
    confirmLogout: "¿Está seguro de que desea cerrar sesión?",
    loggingOut: "Cerrando sesión...",
    confirmSwitch: "¿Está seguro de que desea cambiar de cuenta? La cuenta actual cerrará sesión",
    developing: "En Desarrollo",
    addressCopied: "Dirección Copiada",
    inviteCodeCopied: "Código de Invitación Copiado"
  },

  wallet: {
    title: "My Wallet",
    address: "Wallet Address",
    addressCopied: "Address copied",
    inviteCode: "Invite Code",
    logout: "Logout",
    login: "Login",
    toasts: {
      networkSwitchCancelled: "Network switch cancelled by user",
      networkConfigNotFound: "Network configuration not found for {chainId}",
      signatureCancelled: "Signature cancelled by user",
      connectionFailed: "Failed to Connect",
      accountSwitched: "Wallet account switched, please reconnect",
      connectionTimedOut: "Connection timed out, please try again",
      loginSuccess: "Login successful",
      logoutSuccess: "Logged out successfully",
      switchNetwork: "Please switch to {chainName} in your wallet before trying to deposit",
      wrongChain: "Unsupported network, please switch to {chainName}",
      switchingNetwork: "Switching network...",
      switchNetworkFailed: "Network switch failed, please manually switch to {chainName} in your wallet"
    }
  },
  market: {
    title: "Market",
    banner: {
      title: "Event Contract",
      desc: "Unlock the earning potential on-chain"
    },
    tabs: {
      main: "Mainstream",
      rise: "Top Gainers"
    },
    types: {
      crypto: "Cryptocurrency",
      stocks: "Stocks",
      forex: "Forex",
      commodities: "Commodities",
      favorites: "Favorites"
    },
    headers: {
      pair: "Pair",
      price: "Last Price",
      change: "Daily Change"
    },
    loading: "Loading...",
    loadingMore: "Loading more...",
    noMoreData: "No more data"
  },
  notice: {
    loginRequired: "Inicia sesión para ver los anuncios",
    empty: "Aún no hay anuncios",
    unpublished: "Despublicado",
    title: "Announcements",
    helpCenter: "Help Center",
    noticeDetail: "Notice Detail",
    viewDetail: "View Details",
    pdfViewer: "PDF Viewer",
    videoPlayer: "Video Player",
    imageViewer: "Image Viewer",
    documentViewer: "Document Viewer",
    clickToViewPdf: "Click to view PDF",
    clickToViewDocument: "Click to view document",
    openInBrowser: "Open in Browser",
    tryingViewer: "Trying viewer {current}/{total}",
    pdfLoadFailed: "PDF preview failed, please download to view",
    downloadPdf: "Download PDF",
    defaultCategory: "Notice"
  },
  trade: {
    title: "Event Contract",
    nextRound: "Next Round",
    posCurrent: "Current",
    aiThenPrefix: 'IA entonces: ',
    aiUnlinked: 'Sin IA vinculada',
    aiNotRecorded: 'No registrado',
    insuranceLabel: "Insurance",
    insuranceNotSelected: 'No seleccionado',
    insuranceInactive: "Sin efecto",
    insuranceTypeNone: "Sin efecto",
    insuranceTypeEvent: "Seguro ordinario activo",
    insuranceTypeEventShort: "Seguro ordinario",
    insuranceTypeAi: "Seguro de IA activo",
    insuranceTypeAiShort: "Seguro de IA",
    insuranceTypeConverted: "Este pedido se convirtió a seguro ordinario",
    insuranceTypeUnknown: "Estado del seguro por confirmar",
    inProgress: "In Progress",
    estimatedPnl: "P&L estimado",
    settlementConfirming: "Confirmando el resultado",
    balanceSyncing: "Sincronizando el saldo",
    pendingReview: "Pendiente de revisión",
    connecting: "Connecting...",
    connectWallet: "Connect",
    orderDetail: {
      title: "Detalles del pedido",
      orderId: "ID del pedido",
      symbol: "Par",
      interval: "Intervalo",
      direction: "Dirección",
      aiDirection: "IA entonces",
      openTime: "Apertura",
      settleTime: "Vence",
      settledAt: "Liquidación",
      openPrice: "Precio de apertura",
      closePrice: "Precio de cierre",
      stake: "Capital",
      premium: "Prima",
      netProfit: "P&L neto",
      status: "Estado",
      orderSource: "Origen del pedido",
      converted: "Conversión de seguro",
      notRecorded: "Sin registro",
      copied: "ID del pedido copiado",
    },
    orderStatus: {
      CREATED: "Creado",
      ACCEPTED: "Aceptado",
      CLOSED: "Cerrado",
      FUNDS_LOCKED: "Fondos bloqueados",
      AWAITING_SETTLEMENT: "Pendiente de liquidación",
      PROCESSING: "Procesando",
    },
    insuranceBalanceInsufficient: "Saldo de la cuenta de seguro insuficiente",
    mainBalanceInsufficient: "Saldo de la cuenta principal insuficiente",
    insuranceBalanceRequired: "El saldo de seguro es insuficiente; no se puede activar el seguro",
    insuranceRulesUnavailable: "Las reglas de prima no están listas; no se puede activar el seguro",
    insuranceMainRequired: "El saldo principal es insuficiente; no se puede activar el seguro",
    preferenceLoading: "Cargando configuración del seguro",
    preferenceLoadFailed: "Error al cargar la configuración del seguro; toque para reintentar",
    preferenceSaveFailed: "Error al guardar la configuración del seguro; reintente",
    preferenceSessionEndedSaveFailed: "La ronda terminó, pero el ajuste de desactivado no se guardó",
    premiumEstimate: "Prima estimada {premium} JOULE (5-10%)",
    premiumShortfallHint: "A la cuenta de seguro le faltan {amount} JOULE",
    premiumEstimateUnavailable: "Aún no se puede estimar la prima",
    premiumBoundEstimate: "Prima estimada de la estrategia vinculada {premium} JOULE",
    insuranceConfirmTitle: "Confirmar prima",
    insuranceConfirmBody: "Vista previa de la prima {premium} JOULE. La vista previa es definitiva. Confirme para enviar.",
    actions: {
      rise: "Long",
      fall: "Short",
      buy: "Buy",
      sell: "Sell"
    },
    holdings: {
      current: "Positions",
      history: "History",
      currentCount: "Posiciones abiertas {n}",
      empty: "No positions",
      historyEmpty: "No history"
    },
    position: {
      openPrice: "Open Price",
      closePrice: "Close Price",
      profitLoss: "profit / loss",
      countdown: "Settlement in",
      calculating: "Calculating...",
      settled: "Settled",
      settling: "Settling",
      active: "Active",
      settledAt: "Settled at"
    },
    modal: {
      amountPlaceholder: "Enter amount"
    },
    pairSelector: {
      title: "Select Pair",
      searchPlaceholder: "Search coins"
    },
    errors: {
      dataNotReady: "Cargando datos, por favor espere"
    },
    marketPause: {
      default: "Mercado temporalmente no disponible. Inténtelo más tarde.",
      lastPriceStreamWarming: "El feed de precios se está preparando. Inténtelo en breve.",
      marketWarming: "El mercado se está preparando. Inténtelo en breve.",
      recovering: "El mercado se está recuperando. Inténtelo en breve.",
      clockNotSynced: "El reloj del servidor no está sincronizado. Inténtelo en breve.",
      symbolUnavailable: "Este par de trading no está disponible"
    },
    toasts: {
      connectSuccess: "Connected successfully",
      connectCancelled: "You have cancelled the connection",
      connectFailed: "Connection failed"
    },
    openPriceLabel: "Apertura",
    secondsUnit: "s",
    amountLabel: "Importe",
  },
  exchange: {
    title: "Flash Swap",
    from: "From",
    to: "To",
    balance: "Balance",
    all: "All",
    placeholder: "Please enter",
    fee: "Fee",
    minAmount: "Minimum swap amount: {amount} {symbol}",
    button: "Swap",
    tradeButton: "Comercio",
    paymentCurrency: "Moneda de pago",
    estimatedGasFee: "Tarifa de gas estimada",
    gasPaymentNote: "Se utilizará el saldo de GetGas para pagar la tarifa de gas",
    slippage: "Deslizamiento",
    auto: "Auto",
    approximately: "Aprox",
    minReceived: "Mínimo recibido",
    exchangeRate: "Tipo de cambio",
    finalAmount: "Cantidad final",
    confirm: "Confirmar",
    swapSuccess: "¡Flash Swap exitoso!",
    swapping: "Intercambiando...",
    confirmTitle: "Confirm Action",
    confirmContent: "Are you sure you want to proceed?",
    toasts: {
      fetchFailed: "Failed to fetch assets",
      enterValidAmount: "Please enter a valid amount",
      minAmount: "Minimum swap amount is {amount} {symbol}",
      swapSuccess: "Swap successful",
      requestFailed: "Request failed",
      insufficientBalance: "Saldo insuficiente, no se puede intercambiar",
      usdtRestricted: "USDT under review; exchange unavailable"
    },
    rateHint: "{usdt} USDT={joule}JOULE, no fee",
    configFee: "Comisión Joule → USDT {fee}",
    configLimits: "Comisión {fee} · Límite de valor bruto {min}–{max} U",
    unlimited: "Ilimitado",
    quoteFailed: "No se pudo obtener la cotización, reintenta"
  },
  globalNode: {
    title: "Global Node"
  },
  eventInsurance: {
    title: "Event Contract Insurance",
    availableBalance: "Available Balance (USDT)",
    fundTransfer: "Fund Transfer",
    fundHistory: "Fund History",
    type: "Type: ",
    all: "All",
    transfer: "Transfer",
    fundTransferTitle: "Fund Transfer",
    currency: "Currency",
    from: "From",
    to: "To",
    availableAccount: "Available Account",
    contractInsuranceAccount: "Contract Insurance Account",
    pleaseEnter: "Please enter",
    confirmTransfer: "Confirm Transfer",
    insufficientBalance: "Insufficient balance",
    transferSuccess: "Transfer successful",
    transferFailed: "Transfer failed",
    transferring: "Transfiriendo...",
    noRecords: "No records",
    selectAccount: "Select Account",
    cannotTransferToSameAccount: "Cannot transfer to the same account",
    cannotTransferContractAccount: "Contract account transfer not supported",
    contractAccount: "Contract Account (TAKER)",
    rulesTab: "Resumen",
    agreementTab: "Acuerdo completo",
    insuranceRulesTitle: "Insurance Rules",
    preview: {
      eventGroup: "I. Reglas de predicción de contrato de evento",
      eventOpen: {
        title: "1. Insurance on",
        points: [
          "With insurance on, premium is based on order size vs account balance: ≤10% of balance → 15% premium; above → 20%.",
          "If the insurance account balance is insufficient, insurance does not take effect"
        ]
      },
      eventLimit: {
        title: "2. Order threshold",
        points: [
          "Max per order is 5,000 JOULE"
        ]
      },
      eventClaim: {
        title: "3. Compensation entitlement rules",
        ok: [
          "50% of compensation goes to personal airdrop quota; every 50 USD unlocks one computing node",
          "30% goes to community airdrop quota by VIP rules; every 50 USD unlocks one computing node"
        ],
        fail: [
          "Lose all stake principal; prediction ends"
        ]
      },
      eventPool: {
        title: "4. Event insurance pool payout:",
        points: [
          "Daily 2% of event insurance pool assets in PANTA is airdropped by node weight to eligible users",
          "When daily pool airdrops reach 50 USD in PANTA, one computing node is reduced"
        ]
      },
      eventProfit: {
        title: "5. P&L rules",
        points: [
          "Correct: receive principal 100% + profit (80%)",
          "Wrong: lose all stake principal; prediction ends"
        ]
      },
      aiGroup: "II. Reglas de predicción AI",
      aiFirst: {
        title: "1. First order requires manual input"
      },
      aiOpen: {
        title: "2. Insurance on",
        points: [
          "With insurance on, pay 5%–10% of the position amount as premium",
          "If the insurance account balance is insufficient, insurance does not take effect"
        ]
      },
      aiLimit: {
        title: "3. Order limits",
        points: [
          "Amounts must follow the position table, and each direction must match the AI signal",
          "If not following the table, it becomes a normal event contract prediction",
          "Eight consecutive losses unlock the stated compensation entitlement",
          "A winning order resets the sequence to step 1"
        ]
      },
      table: {
        level: "Account level",
        order1: "Order 1",
        order2: "Order 2",
        order3: "Order 3",
        order4: "Order 4",
        order5: "Order 5",
        order6: "Order 6",
        order7: "Order 7",
        order8: "Order 8"
      },
      claimOk: "Eligible for compensation",
      claimFail: "Not eligible for compensation",
      claimFailWhen: "When not eligible:",
      claimPrereq: "Compensation prerequisites:",
      aiClaim: {
        title: "4. Compensation entitlement",
        prereq: [
          "Insurance enabled",
          "Direction matches AI signal",
          "Amount/order follows the table",
          "Full settlement conditions met"
        ],
        ok: [
          "Cash compensation = cumulative loss × 90%"
        ],
        fail: [
          "Lose all stake principal; prediction ends"
        ]
      },
      aiProfit: {
        title: "5. Profit rules",
        points: [
          "Correct: receive principal 100% + profit 80%",
          "Wrong: lose all stake principal; prediction ends or compensation applies"
        ]
      }
    },
    rulesContent: "PANTA Market Acuerdo de Seguro del Plan de Protección de Operaciones de Contratos de Eventos\n\n【Aviso importante】Antes de utilizar este servicio, lea atentamente y comprenda plenamente todo el contenido del acuerdo. El sistema considerará que, al activar el usuario el 「Interruptor de seguro」, usted ha leído, comprendido y aceptado plenamente el acuerdo y los anexos, confirma que el acuerdo tiene fuerza legal vinculante y acepta cumplirlo estrictamente; si no está de acuerdo y no lo acepta, deje de utilizar de inmediato este plan de protección.\n\nArtículo 1: Disposiciones generales y ámbito de aplicación\n\n1.1 Este acuerdo describe la forma de participación, constitución de órdenes, comisiones, determinación de resultados, liquidación de fondos, indemnizaciones condicionales y derechos de nodos relacionados, así como las funciones de predicción de eventos de las dos funciones 「Predicción de contrato de evento」 y 「Predicción de contrato de evento AI」 dentro de PANTA Market. Cada producto se rige por sus cláusulas específicas; no se pueden aplicar directamente las tarifas, condiciones de indemnización o reglas de nodos de un producto al otro.\n1.2 La predicción de contrato de evento es la función mediante la cual el usuario emite un juicio sobre un evento previamente indicado y sus resultados opcionales, utiliza JOULE para enviar y crear una orden. La pérdida calificada final puede, según reglas aprobadas, generar un límite de nodo personal o de equipo comunitario; dicho límite no constituye una indemnización en efectivo inmediata. La predicción de contrato de evento AI es la función mediante la cual el usuario, con referencia a la señal válida de dirección de predicción AI proporcionada por el sistema, confirma participación orden por orden según el importe fijo y el orden del plan seleccionado para crear órdenes. Cuando las 8 órdenes de una misma secuencia calificada se liquidan por completo y todas resultan pérdidas, y se cumplen simultáneamente otras condiciones explícitas, la indemnización en JOULE se calcula al 90% del total del capital principal calificado. La señal AI no garantiza el resultado, y la indemnización condicional no cubre todos los gastos.\n1.3 Este acuerdo, los parámetros versionados del producto correspondiente, las reglas específicas del evento y la página de confirmación del usuario constituyen conjuntamente las reglas completas. La página solo puede mostrar parámetros ya aprobados y no puede sustituir la ausencia de condiciones clave con la expresión 「prevalece la página」. Si hay contradicciones entre documentos, se deben suspender las nuevas operaciones afectadas y explicar, verificar y corregir; no se puede elegir unilateralmente después una interpretación menos favorable al usuario para tratar órdenes existentes.\n1.4 Este proyecto implica activos reales, predicción de eventos, indemnizaciones condicionales y denominación de seguro, recompensas de equipo, intercambio y pools de fondos, y no es un producto que pueda omitir la revisión de riesgo y cumplimiento. La naturaleza jurídica, licencias, regiones de prestación, elegibilidad de usuarios, AML, protección al consumidor y requisitos de tratamiento de datos de cada función deben verificarse profesionalmente según el alcance real del servicio. Las cláusulas de exención de responsabilidad no sustituyen licencias necesarias, disposición de fondos y medidas de control; este borrador no presupone la aplicación de la ley de un país concreto ni afirma que el producto ya esté legalmente autorizado para operar.\n\nArtículo 2: Terminología y estado de los fondos\n\n2.1 JOULE es la unidad de medida del capital principal de predicción, prima de seguro e indemnización AI en el diseño de este producto; PANTA es la unidad de activo utilizada en la distribución de derechos de nodos y otras operaciones; el equivalente USDT es la base de medición para parte de los límites y cálculos de valor. Los tres no pueden mezclarse; la visualización interna de cifras no implica conversión inmediata a moneda legal a tipo de cambio fijo, ni equivale a que la transferencia on-chain de activos ya se haya completado; esta aclaración no cancela derechos patrimoniales u obligaciones de pago ya formados conforme a ley y contrato.\n2.2 El capital principal de la orden es el importe en JOULE que el usuario confirma efectivamente y que el sistema acepta en dicha orden, sin incluir la prima. La prima es el coste calculado según las reglas aplicables a esa orden. El total congelado suele ser la suma del capital principal y la prima; si hay otros costes deben revelarse por separado de antemano, y no se pueden añadir cargos no confirmados al liquidar.\n2.3 El saldo disponible es el saldo utilizable para nuevas operaciones según las reglas actuales de la cuenta. El saldo congelado es el reservado para órdenes aceptadas u operaciones aprobadas, temporalmente no utilizable para otras acciones. Beneficios previstos, indemnizaciones pendientes de revisión, límites de nodos y distribuciones no contabilizadas no se incluyen en el saldo disponible. La visualización del saldo debe indicar el nombre del activo; no se permite sumar directamente cantidades de activos distintos.\n2.4 La secuencia AI es el registro de operaciones encadenadas desde la 1.ª orden según reglas para el mismo plan confirmado. El paso actual, el resultado de la orden y las pruebas de elegibilidad los mantiene el servidor. La desconexión normal o salir de la app no constituye terminación de la secuencia; el reinicio es terminar la secuencia antigua tras cumplir las condiciones de este acuerdo.\n2.5 El límite de nodo de potencia de cómputo es la unidad contable equivalente a USDT acumulada según reglas a partir de la pérdida calificada final, usada para generar nodos. El nodo es un registro de elegibilidad para participar en distribuciones posteriores de derechos, no efectivo inmediato ni PANTA acreditado, y no se convierte por su nombre en un NFT on-chain negociable, stakeable o libremente transferible.\n2.6 La instantánea de reglas es la versión de reglas, parámetros, importes, base de precio, cláusulas y pruebas relacionadas guardadas al confirmar la orden o secuencia. Una nueva versión publicada no puede sobrescribir instantáneas antiguas. Los registros del servidor sirven para verificar el estado de operaciones, pero el usuario puede aportar otras pruebas para solicitar revisión; no se pueden excluir objeciones razonables solo porque los registros los guarda la plataforma.\n\nArtículo 3: Elegibilidad de uso y confirmación del acuerdo\n\n3.1 La plataforma solo puede ofrecer las funciones correspondientes a usuarios dentro de regiones de servicio, rangos de edad y de idoneidad aprobados. La versión oficial debe especificar requisitos de verificación de identidad, alcance de productos disponibles y motivos de restricción. No se puede considerar elegible para todos los productos solo porque la wallet esté conectada, la interfaz sea visible o la cuenta tenga saldo.\n3.2 El usuario debe utilizar cuentas y activos bajo su control legítimo; está prohibido suplantar identidad, usar cuentas ajenas sin autorización, falsificar documentos de elegibilidad o manipular señales o pruebas de resultados. Si la plataforma requiere verificación adicional, debe explicar los documentos necesarios y el propósito operativo; las restricciones a nueva participación y el cumplimiento de órdenes existentes deben explicarse por separado.\n3.3 Antes de ordenar, el usuario debe poder consultar capital principal, prima, posibles costes adicionales, opciones de predicción, peor pérdida, condiciones de liquidación, fuente de determinación y vía de disputa. La plataforma debe ofrecer pasos de confirmación claros y no sustituir la confirmación real del usuario con consentimiento por defecto, costes ocultos, cambio automático de importe o presión para repetir operaciones.\n3.4 Señales AI, resultados históricos, beneficios de ejemplo, tamaño del pool de nodos y registros de derechos de terceros no constituyen promesa de resultados futuros. El usuario puede perder el capital principal de órdenes aceptadas y primas relacionadas; los derechos de nodos también pueden verse afectados por saldo del pool, peso efectivo, precio y estado de procesamiento. El usuario no debe tomar un ejemplo concreto como renta fija propia o plazo de recuperación determinado.\n\nArtículo 4: Reglas de predicción de contrato de evento\n\n4.1 Antes de iniciar una secuencia AI, el usuario debe revisar planes disponibles, capital principal de posición de ejecución, prima estimada, necesidad total de fondos, validez de la señal, regla de liquidación de 60 segundos y condición de indemnización del 90%. Una secuencia nueva solo puede empezar desde la 1.ª orden; no se puede cambiar de plan durante la secuencia; el usuario no puede combinar saltos de paso, cambio de importe u órdenes pendientes en paralelo para formar una nueva secuencia calificada. Tras elegir el resultado del evento e introducir capital principal en JOULE, la plataforma calcula la prima según la base de posición aprobada. Diseño actual: si el capital principal no supera el 10% de la base de posición, la prima es el 15% del capital principal; si supera el 10%, el 20%. En el límite exacto del 10% aplica el 15%.\n4.2 La señal AI debe mostrar activo, dirección, hora, validez y número de señal identificable. Al ordenar, el usuario debe confirmar dirección coherente con la señal válida en ese momento. Si la señal se actualiza durante espera o reconexión, debe revalidarse; una señal caducada no puede seguir usándose desde caché del cliente. Adoptar señal AI no significa que la plataforma o el algoritmo conozcan el resultado futuro. Precisión histórica, registros demo y explicaciones de predicción no garantizan el resultado de esta orden. La plataforma no puede usar expresiones como 「ganancia segura」, 「beneficio estable」 o 「sin pérdida si falla」 en lugar del capital principal, prima y condiciones reales de indemnización.\n4.3 Cada evento debe indicar por separado nombre, descripción factual, resultados opcionales, momentos de apertura y cierre, zona horaria, límites de participación, criterios de determinación del resultado, fuentes principales y de respaldo, cálculo de beneficio, peor pérdida, reglas de cancelación o aplazamiento y procedimiento de reclamación. Para eventos ambiguos, sin criterios de determinación o con parámetros económicos clave no aprobados, no se puede abrir orden real. Al aceptar la orden, la plataforma debe verificar que el evento sigue abierto, que la hora del servidor es anterior al cierre, que opciones y versión son válidas, que elegibilidad y límites del usuario se cumplen y que hay saldo suficiente. El cierre no se juzga por la hora del dispositivo del usuario ni por si el cliente aún muestra cuenta atrás al hacer clic.\n4.4 Tras congelar con éxito capital principal y prima y aceptar la orden, la plataforma devuelve hora de aceptación y momento de liquidación pactado. Ese momento se calcula como hora de aceptación del servidor más 60 segundos, no desde abrir la página, recibir la señal o pulsar el botón. La latencia de red no acorta ni alarga el criterio de determinación ya fijado. 60 segundos indican el momento pactado de determinación del resultado, sin prometer abono de fondos en el mismo instante en que la cuenta atrás del cliente llega a cero. Al llegar el momento, debe obtenerse prueba del resultado de la fuente pactada; sin prueba, fuente anómala o conflicto de resultados, se mantiene pendiente de liquidación con explicación, sin registrar automáticamente pérdida.\n4.5 Solo cuando hay secuencia válida actual, reglas mostradas claramente y sin órdenes pendientes, y el usuario envía efectivamente dirección distinta de la señal válida o importe distinto del paso fijo actual, aplica el diseño de rechazo y reinicio que termina la secuencia antigua. Deben mostrarse motivo concreto, secuencia afectada y siguiente acción ejecutable, conservando el historial. Tras reinicio, la siguiente vez puede crearse secuencia nueva desde la 1.ª orden; no se pueden concatenar órdenes perdidas de la secuencia antigua con las de la nueva para calcular 8 pérdidas consecutivas. Pérdidas y ganancias completadas en la secuencia antigua se conservan y no reciben automáticamente indemnización del 90%; ello no impide solicitar revisión por error de plataforma, reinicio incorrecto u otra disputa.\n4.6 La solicitud infractora rechazada no se ejecuta y no genera nueva pérdida de capital principal, prima o nodo de pérdida. La redacción en material original sobre convertir pérdida infractora en nodo aún no forma regla ejecutable; no puede usarse para inventar pérdidas o compensaciones en órdenes rechazadas.\n4.7 Que el usuario pause el inicio de pasos posteriores no equivale a haber formado 8 pérdidas consecutivas; una secuencia incompleta no puede solicitar indemnización del 90% proporcional al número de órdenes perdidas. Terminación activa de secuencia, estancia prolongada y plazos de recuperación requieren confirmación formal de reglas; no se puede añadir por cuenta propia un plazo de caducidad no revelado. Salida normal y desconexión no se interpretan como renuncia voluntaria. Una misma secuencia debe cumplir simultáneamente estas cuatro condiciones para calcular indemnización del 90% en JOULE según el diseño actual: en cada orden el mecanismo de seguro está activo y capital principal y prima de esa orden se congelan con éxito; dirección de cada orden coherente con señal AI válida al aceptar; capital principal y orden de pasos de cada orden conforme al plan confirmado; las 8 órdenes se liquidan por completo y todos los resultados son pérdidas calificadas. El importe de indemnización es el total del capital principal de participación de 8 órdenes calificadas multiplicado por 90%, medido y pagado en JOULE; la prima no entra en esa base del 90%. La indemnización no puede expresarse directamente como devolución del 90% de todos los gastos, ni convertirse automáticamente a USDT, efectivo o PANTA. El intercambio de otros activos requiere reglas y autorización independientes.\n4.8 La constitución de elegibilidad de indemnización y el pago exitoso son dos fases. Con elegibilidad pero fondos insuficientes, anomalía contable o restricciones aplicables, se conservan obligación y detalle pendientes de pago, se muestra procesamiento o motivo claro de suspensión, y se actúa conforme a ley y contrato; no se puede reescribir dificultad de pago como falta de elegibilidad del usuario.\n4.9 La indemnización se ejecuta una sola vez según el registro único de esa secuencia. Si el pago fue exitoso pero se perdió la respuesta, consultas y reintentos posteriores deben devolver el resultado original sin pago duplicado. El fallo de pago debe mantener estado real de incompleto; no se puede exigir al usuario crear secuencia nueva o reordenar para 「activar」 la indemnización original. Si en una misma secuencia el mecanismo de confirmación previa permite tarifas distintas por orden, debe guardarse instantánea por orden y acumularse coste real; no se puede recalcular todas las órdenes históricas con una sola tarifa actual. Cambios de mecanismo tarifario que afecten secuencias ya confirmadas deben definir primero su ámbito; no se puede aumentar coste retroactivamente mediante nueva página.\n4.10 Unidad mínima de activo, precisión, método de redondeo por orden y tratamiento de restos deben fijarse antes del lanzamiento y mantenerse coherentes. El redondeo en página para legibilidad no debe alterar detalle contable; la precisión en ejemplos de cálculo no es la precisión de pago ya aprobada. Comisiones, spread y restos no pueden ocultarse mediante visualización combinada.\n\nArtículo 5: Servicios del sistema\n\n5.1 Desconexión o tiempo de espera agotado: el usuario consulta primero la orden original; la plataforma devuelve estado real aceptado, rechazado explícitamente o aún pendiente de confirmación. Con resultado original desconocido no se debe inducir pago duplicado; solo tras confirmar posteriormente no aceptación puede reconfirmarse nueva solicitud según reglas vigentes.\n5.2 Señal o cotización caducada: rechazar solicitud antigua, mostrar motivo y volver a obtener contenido. No se puede sustituir silenciosamente por nueva dirección, importe o coste, ni tratar caducidad automáticamente como reinicio por infracción AI. Si la solicitud antigua ya fue aceptada, se cumple según su instantánea.\n5.3 Resultado o precio anómalo: suspender determinación, valoración o distribución afectada; proporcionar estado, alcance afectado y canal de consulta. Resultado ausente no puede registrarse como pérdida por fallo; valoración anómala no puede ampliar base de pérdida. Cambio de fuente de respaldo debe seguir orden de fuentes y reglas de anomalía previamente publicadas.\n5.4 Diferencia contable o estado de transacción externa desconocido: verificar primero registro original y acuse externo; no reenviar acciones irreversibles. Tras confirmar fallo, descongelar o reintentar según reglas correspondientes; desconocido no equivale a reembolso completado. Acciones de fondos del usuario completadas y pasos posteriores de compra de moneda o entrada al pool incompletos deben mostrarse por separado.\n5.5 Escasez de fondos: detener nuevas operaciones relacionadas que puedan ampliar el déficit, conservar obligaciones ya formadas, informar estado pendiente y actuar según plan aprobado. No se puede falsificar abono, poner saldo disponible en negativo ni cubrir diferencia con cargos adicionales no informados.\n5.6 Restricciones de riesgo: la plataforma puede realizar verificaciones o restricciones necesarias según reglas formalmente aprobadas y debidamente reveladas, pero debe distinguir restricción de nuevas órdenes, retraso de pago y cancelación de elegibilidad. Las restricciones no pueden reescribir automáticamente resultados históricos o condiciones económicas ya cumplidas; excepciones requieren hechos y fundamento, con canal de revisión disponible.\n5.7 En mantenimiento, cese de servicio o cierre de producto, deben existir disposiciones para órdenes históricas, indemnizaciones, disputas y registros verificables. Que el usuario no pueda añadir operaciones no implica desaparición de saldo existente, indemnizaciones debidas o derecho de reclamación. Apagar el interruptor de nuevas operaciones no debe cerrar simultáneamente toda consulta histórica y procesos de cumplimiento.\n\nArtículo 6: Cláusulas de exención de responsabilidad\n\nPor pérdidas causadas por las siguientes circunstancias, el servicio no asume responsabilidad de indemnización:\n6.1 Incumplimiento de estrategia: cualquier conducta que se aparte de la normativa estándar de gestión de posiciones de esta plataforma\n6.2 Condiciones extremas de mercado: pérdidas por parálisis de exchange, agotamiento de liquidez o manipulación de mercado\n6.3 Riesgos de sistema y operación: pérdidas por fallo del dispositivo del usuario, error operativo o robo de cuenta\n6.4 Riesgos de política y cumplimiento: interrupción o prohibición de operaciones por cambios legales, normativos o órdenes regulatorias\n6.5 Riesgo del token intrínseco: caída brusca o colapso de capitalización de JOULE que afecte su función como margen y moneda de liquidación\n6.6 Fraude y conducta maliciosa: participación del usuario en fraude, blanqueo de capitales, manipulación de mercado u otras actividades ilegales\n6.7 Fuerza mayor: fallo del sistema de esta plataforma por fuerza mayor\n\nArtículo 7: Divulgación de riesgos\n\nEl usuario confirma haber comprendido plenamente y aceptar los siguientes riesgos:\n7.1 Sin garantía de capital ni de beneficio: este plan solo indemniza parte de las pérdidas y no garantiza absolutamente la seguridad del capital ni beneficios\n7.2 Riesgo de dependencia de estrategia: el efecto de protección depende totalmente del cumplimiento estricto de la estrategia\n7.3 Riesgo de liquidez y bloqueo: fondos de indemnización en cuenta de gestión patrimonial pueden implicar riesgo de inversión y periodo de bloqueo, afectando la liquidez\n7.4 Riesgo de terceros: riesgos operativos, de seguridad y de fluctuación de valor de los exchanges de los que depende\n7.5 Riesgo de incertidumbre regulatoria: esta plataforma enfrenta incertidumbre regulatoria global y riesgo de suspensión\n7.6 Riesgo de seguridad tecnológica: incluye riesgo de pérdida de activos por vulnerabilidades de smart contract, ataques informáticos, etc.\n\nArtículo 8: Modificación, terminación y disputas del acuerdo\n\n8.1 Modificación del acuerdo: esta plataforma se reserva el derecho de revisar este acuerdo conforme a ley o necesidades operativas; cambios importantes se notificarán mediante anuncio de la plataforma\n8.2 Terminación del acuerdo: el usuario puede desactivar el interruptor de protección en cualquier momento para terminar el servicio; si incumple el acuerdo, la plataforma puede terminar unilateralmente; por motivos legales o de política este plan puede terminarse\n8.3 Resolución de disputas: las disputas derivadas de este acuerdo se resolverán mediante negociación amistosa; si fracasa, se someterán al organismo arbitral o tribunal designado\n\n【Confirmación final】Usted entiende y acepta que 「Activar el interruptor de seguro」 es la única y definitiva forma de confirmar que queda vinculado por todo el contenido de este acuerdo; tome la decisión con juicio independiente.",
    lockedBalance: "Non-transferable",
    equityTitle: "Event insurance equity",
    personalEquity: "Personal equity",
    teamEquity: "Team equity",
    equityNodes: "Active nodes",
    remainingEquity: "Remaining equity",
    peersPaid: "Peer paid",
    peersPending: "Peer pending",
    creditsCount: "Credit rows",
    nodeBatches: "Node batches",
    peerRows: "Pending peer rows",
    recentPayouts: "Recent payouts",
    premiumRules: "Position threshold {threshold}% · low premium {low}% · high premium {high}% (preview wins per order)",
    insuranceDeduction: "Insurance premium deduction (Event)",
    insurancePayout: "Insurance premium payout (Event)"
  },
  aiPrediction: {
    stakeAutofill: "Asistencia IA",
    stakeAutofillWarning: "Solo asistencia. El importe sugerido puede fallar; compruébelo antes de ordenar. El autocompletado se pausa si la latencia supera 800 ms o falla/expira la comprobación, y se reanuda al recuperarse. No afecta pedidos manuales.",
    stakeAutofillUnavailable: "Conexión inestable o superior a 800 ms. Aún no se puede activar.",
    stakeAutofillPaused: "Autocompletado en pausa: conexión inestable. Introduzca el importe manualmente.",
    insuranceSyncing: "Sincronizando el paso del seguro…",
    predictionBuffer: 'Preparando la siguiente predicción',
    scheduleResultPending: 'Resultado no disponible, reintentando',
    title: "AI Prediction",
    bookingTitle: "Reserva de sesiones IA",
    bookingExpand: "Expandir",
    bookingCollapse: "Contraer",
    bookingNextSystem: "Próxima sesión · SGT",
    bookingNextMine: "Mi próxima reserva",
    bookingNone: "Ninguna",
    bookingStartingSoon: "Tu sesión reservada empieza pronto",
    bookingToday: "Hoy",
    bookingTomorrow: "Mañana",
    bookingTimezone: "SGT",
    bookingQuota: "Sesiones restantes: {remaining}/{dailyLimit}",
    bookingSeats: "{occupied}/{capacity} plazas",
    bookingEmpty: "No hay sesiones disponibles",
    bookingWaiting: "Entrarás automáticamente al terminar la operación actual",
    bookingEnded: "Finalizada",
    bookingJoin: "Unirse a la sesión",
    bookingReserve: "Reservar",
    bookingJoined: "Unido",
    bookingReserved: "Reservado",
    bookingFull: "Completo",
    bookingConfirm: "Confirmar reserva",
    bookingWarning: "Una reserva exitosa usa 1 sesión del día; cuenta aunque no asistas.",
    bookingQuotaExhausted: "Has usado todas las sesiones disponibles hoy",
    bookingUnavailable: "La reserva no está disponible",
    bookingFailed: "Error al reservar. Actualiza e inténtalo de nuevo.",
    aiPool: "Pool AI",
    countdown: "Countdown",
    expectedProfit: "Expected Profit",
    active: "Active",
    aiAnalysis: "AI Smart Rise/Fall Probability Analysis",
    updateTime: "Update Time",
    probabilityUp: "Bullish Probability",
    probabilityDown: "Bearish Probability",
    startPrediction: "Start Prediction",
    predicting: "Predicting...",
    stayOnPageHint: "No salgas de esta página; si lo haces, el resultado de la predicción puede perderse.",
    userInfo: "User Info",
    predictCount: "Prediction Count",
    freeCount: "Free Predictions",
    openTime: "Open at: {time1}",
    up: "Up",
    down: "Down",
    notConnected: "Not Connected",
    count: "Count",
    learnMore: "Learn More",
    calculating: "Calculating...",
    settled: "Settled",
    loginFirst: "Please login first",
    sessionSyncing: "Sincronizando",
    actions: {
      rise: "Long",
      fall: "Short"
    },
    holdings: {
      current: "Positions",
      history: "History",
      empty: "No positions",
      historyEmpty: "No history",
      aiHistory: "AI History",
      aiHistoryEmpty: "No AI history"
    },
    buyModal: {
      title: "Comprar Privilegio",
      description: "Comprar 30 Predicciones IA",
      upgradeAmount: "Monto de Actualización",
      balance: "Saldo Disponible",
      cancel: "Cancel",
      confirm: "Confirmar",
      purchasing: "Comprando...",
      purchaseSuccess: "Compra Exitosa",
      purchaseFailed: "Compra Fallida",
      dailyLimit: "You can purchase once per day."
    },
    noPredictionAlert: {
      title: "Fallo en Predicción IA",
      description: "Su conteo de predicciones IA es 0. No puede usar la predicción IA en este momento. Por favor compre para continuar.",
      cancel: "Cancelar",
      confirm: "Comprar Predicción IA"
    },
    toasts: {
      predictionFailed: "Prediction failed",
      predictionSuccess: "Prediction completed",
      premiumShortfallReminder: "Full-round premium shortfall ~{amount} JOULE (reminder only; this order can still submit)",
      deferredWaitSettlement: "Signal ready; wait for the open position to settle before placing",
      insuranceTierUnavailable: "Insurance tier unavailable; try again later",
      insuranceCancelFailed: "Cannot close; unsettled orders may exist",
      resumeFailed: "Failed to resume prediction; try again later",
      requiredStakeInvalid: "Invalid prediction stake; start AI prediction again"
    },
    analyzing: "Analyzing...",
    insurance: "Seguro",
    insuranceOn: "Activo",
    insuranceOff: "Inactivo",
    aiLabel: "AI",
    lookLong: "Alcista",
    lookShort: "Bajista",
    waitingResult: "Waiting",
    startAIPrediction: "Start AI Prediction",
    scheduleConfirm: "Seguir esta ronda",
    scheduleBinding: "Vinculando señal...",
    predictionResult: "AI Prediction Result",
    nextRound: "Next Round",
    rise: "Long",
    fall: "Short",
    openPrice: "Precio de apertura",
    settledAt: "Liquidado a las",
    ordinaryInsuranceTitle: "Este pedido es seguro ordinario",
    ordinaryInsuranceBody: "Este pedido es seguro ordinario, no un pago de ronda de IA. La prima sigue la vista previa tras confirmar.",
    sessionConflict: "Hay una ronda de seguro de IA activa. Restáurala o termínala antes del seguro ordinario.",
    conversionTitle: "¿Convertir a seguro ordinario?",
    conversionDesc: "Este pedido pasará a seguro ordinario y terminará la ronda de seguro IA. Las rachas de pérdidas IA anteriores no se pagarán. Prima ordinaria {premium} JOULE.",
    conversionConfirm: "Confirmar conversión y orden",
    stakeFromStrategy: "El tamaño lo fija la estrategia",
    stakeTier: "Nivel {tier}",
    stakeStep: "Paso {step}",
    selfQuotaRemaining: "Autopredicción restante: {remaining}/{limit}",
    followRoundProgress: "Seguimiento IA · Ronda {current}/{total}",
    followRoundsCompleted: "Seguimiento IA finalizado · {current}/{total}",
    selfQuotaLoadingShort: "Cargando cupo…",
    selfQuotaLoginHint: "Inicia sesión para ver el cupo",
    selfQuotaLoading: "Cargando cupo, inténtalo más tarde",
    selfQuotaExhausted: "Cupo gratis de autopredicción agotado hoy; la predicción de pago aún no está abierta"
  },
  positionModal: {
    title: "Predicción de precio",
    insurance: "Seguro",
    long: "Largo",
    short: "Corto",
    balance: "Saldo",
    loading: "Cargando...",
    confirm: "Confirmar",
    processing: "Procesando orden...",
    success: "¡Orden realizada con éxito!",
    insuranceOn: "Seguro activado",
    insuranceOff: "Seguro desactivado",
    operationFailed: "Operación fallida",
    balanceFetchFailed: "Error al obtener saldo",
    minAmount: "La cantidad mínima es 0.1 TAKER",
    insufficientBalance: "Saldo insuficiente, saldo actual: {balance} TAKER",
    createFailed: "Error al crear posición",
    recoverTitle: "Recover pending order",
    recoverContent: "Unconfirmed order found ({symbol} {direction} {amount}). Will reuse the original idempotency key without requoting.",
    recoverConfirm: "Recover",
    recoverCancel: "Cancel"
  },
  appeal: {
    title: "Asistencia de Auditoría de Activos",
    records: "Registros de Envío",
    recordsTitle: "Registros de Envío",
    noRecords: "Sin registros de envío",
    submitTime: "Hora de Envío",
    statusPending: "Pendiente",
    statusApproved: "Aprobado",
    statusRejected: "Rechazado",
    failedReason: "Motivo de Rechazo",
    uniLiveUid: "UniLive ID",
    uniLiveUidLoading: "Cargando...",
    walletAddress: "Dirección vinculada a PANTA MARKET",
    address: "Dirección",
    walletAddressPlaceholder: "Ingrese la dirección de inicio de sesión de PANTA MARKET",
    autoFill: "Autocompletar",
    depositAmount: "Monto del depósito",
    depositAmountPlaceholder: "Ingrese el monto del depósito",
    tokenType: "Tipo de token",
    selectToken: "Seleccione el token",
    tokens: {
      usdt: "USDT",
      taker: "JOULE"
    },
    transferTime: "Hora de transferencia",
    selectTime: "Seleccione la hora de transferencia",
    timeRangeHint: "Datos relevantes generados entre el 5 de marzo de 2026 00:00 y el 11 de marzo 10:00 (SGT).",
    txHash: "HASH / TXID",
    txHashPlaceholder: "Ingrese el hash de la transacción",
    txHashHint: "Se puede consultar en el explorador de blockchain",
    uploadImages: "Captura de pantalla del registro de transferencia",
    uploadHint: "Opcional, cargue hasta 9 imágenes",
    addImage: "Agregar imagen",
    submit: "Enviar",
    submitting: "Enviando...",
    submitSuccess: "Enviado con éxito",
    submitFailed: "Error al enviar, intente nuevamente",
    uploadingImages: "Subiendo imágenes...",
    uploadImagesFailed: "Error al subir imágenes",
    warningTitle: "Aviso importante",
    warningText: "Si el registro enviado se verifica con éxito, recibirá una recompensa del 5% del poder de suscripción. Si se proporciona información falsa, la cuenta será congelada."
  },
  withdrawSheet: {
    title: "Retirar",
    balance: "Saldo",
    processing: "Retirando TAKER...",
    success: "¡Retiro de TAKER exitoso!",
    withdrawing: " retirando...",
    withdrawSuccess: " Enviado para revisión",
    recordBadge: "Withdraw Record",
    sheetTitle: "Withdraw {token}",
    sheetDesc: "Enter the amount to withdraw. Minimum {min} USDT. No fees.",
    available: "Available {token}",
    amountPlaceholder: "Enter amount (min {min} USDT)"
  },
  depositSheet: {
    title: "Depositar TAKER",
    depositTo: "Depositar en",
    spotAccount: "Cuenta Spot",
    network: "Red",
    networkWarning: "Solo se admiten depósitos a través de la red BSC/BEP20. Las pérdidas de activos causadas por el uso de otras redes no se pueden recuperar.",
    depositAddress: "Dirección de depósito",
    address: "Dirección",
    depositTAKER: "Depositar TAKER",
    recharge: "Recargar",
    rechargeAddress: "Dirección de recarga",
    copy: "Copiar",
    copySuccess: "Copiado exitosamente",
    loadingAddress: "Obteniendo dirección de recarga...",
    loadAddressFailed: "Error al obtener dirección de recarga",
    clickToRetry: "Haga clic para reintentar",
    saveAndShare: "Guardar y compartir dirección",
    generating: "Generando...",
    generateSuccess: "Generado exitosamente",
    generateFailed: "Error al generar",
    more: "Más",
    save: "Guardar",
    wechat: "WeChat",
    recordBadge: "Deposit Record",
    sheetDesc: "Deposit {token} from your wallet to platform balance",
    telegram: "Telegram",
    discord: "Discord",
    x: "X",
    savedImage: "Imagen guardada",
    download: "Descargar",
    pleaseGenerate: "Por favor genere la imagen primero",
    downloadSuccess: "Descarga exitosa",
    saveSuccess: "Guardado exitoso",
    saveFailed: "Error al guardar",
    needPermission: "Se necesita permiso para guardar la imagen en el álbum",
    pleaseUseDapp: "Por favor, use la billetera para abrir la operación dapp",
    claimDesc: "Transfer USDT to the deposit address, then paste the tx hash to claim",
    claimButton: "Claim Deposit",
    environment: "Environment",
    txHash: "Transaction Hash",
    txHashPlaceholder: "Paste 0x transaction hash",
    optionalAmount: "Amount (optional note)"
  },
  sidebar: {
    loginAccount: "Iniciar sesión en la cuenta",
    inviteBanner: "Invita amigos y gana comisiones de equipo",
    inviteCode: "Código de invitación",
    defaultName: "PANTA MARKET",
    logoutWallet: "Disconnect Wallet"
  },
  teamDetails: {
    myReferrals: "Mis referidos",
    currentLevel: "Nivel actual: {level}",
    nextLevel: "Siguiente nivel",
    totalMembers: "Referencias directas",
    validMembers: "Miembros válidos",
    teamLevel: "Nivel de equipo: {level}",
    tradeTeam: "Equipo de trading",
    financeTeam: "Equipo financiero",
    teamMembers: "Miembros del equipo",
    teamData: "Team Data",
    teamEarningsJoule: "Team Earnings (WATT)",
    myCurrentLevel: "My level: {level}",
    currentTotalPerf: "Total performance: {value}",
    currentAreaPerf: "Area performance: {value}",
    inviteDetails: "Invite details",
    startDate: "Start date",
    dateTo: "to",
    endDate: "End date",
    editRemark: "Edit note",
    addRemark: "Add note",
    viewDetail: "View details",
    status: "Status: ",
    time: "Time: ",
    level: "Level: ",
    inviteType: "Invite type: ",
    viewTeam: "View team",
    communityValidCount: "Community actives: ",
    communityTotalPerf: "Community volume: ",
    areaTotalPerf: "Area volume: ",
    yesterdayStake: "Yesterday stake: ",
    communityMaxLevel: "Community top level: ",
    personalEquity: "Personal equity: ",
    remarkPlaceholder: "Enter a note",
    saveRemark: "Update",
    filterAll: "All",
    filterDirect: "Direct",
    filterIndirect: "Indirect",
    viewingIndirect: "Directos de {name}",
    teamPowerUsdt: "Team Power (USDT)",
    teamFlowJoule: "Team Volume (WATT)",
    statusInvalid: "Inactive",
    statusValid: "Active",
    peopleUnit: "{n}",
    remarkSaved: "Note saved"
  },
  teamMemberModal: {
    totalProfit: "Beneficio total",
    totalFlow: "Flujo total",
    totalInvites: "Total de invitaciones",
    validMembers: "Total de miembros válidos"
  },
  fundRecords: {
    feeLabel: "Fee: {fee}",
    withdrawTitle: "Withdraw Records",
    exchangeTitle: "Exchange Records",
    depositTitle: "Deposit Records"
  },
  aiAssistant: {
    title: "PANTA MARKET",
    newChat: "Nuevo chat",
    manual: "Manual",
    manualCardTitle: "Open operation manual",
    manualCardDesc: "Illustrated steps for deposit, exchange, transfer, and AI prediction",
    hello: "Hola, soy tu asistente de IA",
    hint: "Pregunta por mercados, dónde ver reglas de seguro de evento/IA, equipo e invitación, o riesgo.",
    placeholder: "Pregunta algo...",
    send: "Enviar",
    thinking: "Analizando...",
    disclaimer: "Solo referencia — no es consejo de inversión.",
    bullish: "Alcista",
    bearish: "Bajista",
    aiAnalysis: "Resumen IA",
    strategy: "Estrategia",
    reasoning: "Razonamiento",
    targetPrice: "Objetivo {price}",
    stopLoss: "Stop {price}",
    takeProfit: "Take profit {price}",
    dirLong: "Long",
    dirShort: "Short",
    dirNeutral: "Neutral",
    analysisDone: "Análisis de {symbol} ({timeframe}) listo. Mira la tarjeta abajo.",
    analysisBtc: "Análisis de BTC a corto plazo.",
    analysisEth: "Análisis de ETH en rango.",
    analysisRisk: "Lectura del riesgo de mercado.",
    suggestions: {
      btc1m: "Analizar outlook BTCUSDT 1m",
      ethTrend: "¿Persigo ETH o espero?",
      marketRisk: "¿Cuál es el apetito de riesgo actual?",
      eventRules: "¿Dónde ver el resumen de reglas del seguro de evento?",
      aiRules: "¿Cómo entender reglas/niveles de predicción IA?",
      teamWhere: "¿Dónde ver detalles del equipo?",
      inviteWhere: "¿Dónde está el enlace de invitación / vincular superior?"
    },
    guides: {
      eventRules: "Reglas del seguro de evento: abre Event Contract y la entrada de reglas junto al interruptor. Vista previa para prima/límites/beneficios; Acuerdo completo para el texto legal.",
      aiRules: "AI Prediction: pestaña central → AI Prediction. Revisa la cuenta atrás de la siguiente ronda, nivel/paso del seguro y cuota de autopredicción. Las reglas están en la misma hoja. La orden debe coincidir en tamaño y dirección del nivel.",
      teamWhere: "Detalles del equipo: barra lateral o Yo → Mi equipo. Cambia ganancias de trade/finanzas y abre Detalles del equipo para referidos, volumen, nivel y miembros.",
      inviteWhere: "Invitación y vínculo: barra/Yo → Invitar amigos para copiar el enlace (?ref=). Si no hay superior, aparece el modal tras iniciar sesión. Sin parámetro de invitación, el campo rellena la dirección por defecto del sistema."
    },
    generic: {
      a: "Entendido. Pregunta por mercados, ubicación de reglas de evento/IA, equipo e invitación, o usa los atajos.",
      b: "OK. Asistente IA: tarjetas de outlook y guías de funciones.",
      c: "Prueba atajos de reglas de evento, reglas IA, detalles del equipo o enlace de invitación."
    }
  },
  createMarket: {
    title: "Create Market",
    saveDraft: "Save Draft",
    marketTitle: "Market Title",
    titlePlaceholder: "Enter market title",
    category: "Category",
    secondaryOptional: "Secondary (opt.)",
    deadline: "Deadline",
    optionsTitle: "Outcomes (2–16)",
    optionsSub: "Name each option",
    resetDefault: "Reset",
    addOption: "+ Add Option",
    ratioHint: "Initial ratio: leave blank to split evenly; if filled, each option needs an integer 1–99 and the total must be 100.",
    rulesSection: "Rules / Settlement Source",
    rulesSectionSub: "Optional — shown in the rules & settlement popup on the detail page",
    rulesLabel: "Rules",
    rulesPlaceholder: "Settlement criteria, edge cases, etc.",
    settleLabel: "Settlement Source",
    settlePlaceholder: "Official site / news / URL",
    liquidityTitle: "Initial Liquidity",
    liquiditySub: "Funds needed to bootstrap the market",
    enabled: "On",
    disabled: "Off",
    investAmount: "Amount (JOULE)",
    balance: "Balance: {n}",
    max: "Max",
    initialLiquidity: "Initial Liquidity",
    marginRefund: "Margin (refunded after settlement)",
    totalTip: "Margin matches liquidity 1:1 and is fully refunded when the event settles or is canceled.",
    totalDeduct: "Total Deduct",
    feeTip: "Tip: you earn a 0.5% creator fee on every trade in this market.",
    accessPassword: "Access Password",
    accessPasswordSub: "The event will show a lock. Only people with the share link or password can enter.",
    passwordPlaceholder: "Set password (4–20 chars)",
    hide: "Hide",
    show: "Show",
    cardPreview: "Card Preview",
    deadlinePrefix: "Ends {date}",
    submitting: "Creating...",
    submit: "Confirm & Add Liquidity",
    createSuccess: "Created",
    creating: "Creating",
    creatingDesc: "Please wait while we submit the market…",
    backHome: "Home",
    createAnother: "Create Another",
    deadlineShort: "{m}/{d}",
    yes: "Yes",
    no: "No",
    optionN: "Option {n}",
    draftSaved: "Draft saved",
    draftSaveFailed: "Failed to save draft",
    resetDone: "Reset to defaults",
    maxOptions: "Up to 16 options",
    minOptions: "Keep at least 2 options",
    needMinOptions: "Need at least 2 options",
    fillOptionName: "Enter a name for option {n}",
    fillAllPercents: "Fill a ratio for every option",
    percentRange: "Ratios must be integers 1–99",
    percentSum: "Ratios must sum to 100 (now {sum})",
    enterTitle: "Enter a market title",
    enterAmount: "Enter an amount",
    insufficientBalance: "Insufficient balance (incl. margin)",
    passwordLength: "Password must be 4–20 characters",
    deadlineFuture: "Deadline must be in the future",
    completeForm: "Please complete the form",
    createdMsg: "“{title}” created. Ends {date} {time}"
  },
  marketDetail: {
    tabTrades: "Operaciones recientes",
    tabLp: "LP",
    tabPositions: "Posiciones",
    tabRules: "Reglas",
    colAddress: "Dirección",
    colTime: "Hora",
    colType: "Tipo",
    colVolumePrice: "Tamaño/Precio",
    colTurnover: "Nocional",
    typeBuy: "Compra",
    typeSell: "Venta",
    empty: "Sin datos",
    share: "Compartir",
    rulesBody: "Este mercado es una predicción binaria. El libro puede bloquearse antes de la liquidación; tras el resultado se liquida según la posición. Atienda los riesgos.",
    priceJoule: "Precio (JOULE)",
    investJoule: "Inversión (JOULE)",
    totalLiquidity: "Liquidez",
    dealPrice: "Precio de ejecución",
    estProfit: "Beneficio est.",
    jouleBalance: "Saldo JOULE: {n}",
    positionCount: "Posiciones: {n}",
    max: "Máx",
    confirmOrder: "Confirmar orden",
    ordering: "Enviando...",
    enterAmount: "Introduce el importe",
    invalidPrice: "Precio no válido",
    amountExceed: "Supera el saldo",
    orderSuccess: "Orden enviada",
    poolSize: "Tamaño del pool",
    colBalance: "Saldo",
    shares: "{n} uds.",
    rulesTitle: "Reglas",
    rulesValue: "Sin descripción",
    settleSource: "Fuente de liquidación",
    settleValue: "Sin descripción"
  },
  rank: {
    applyTitle: "Become an Expert",
    applyDesc: "Show your trading talent and earn revenue share",
    applyCta: "Join Now",
    tabExpert: "Expert Ranking",
    tabMaker: "Market Maker",
    tabWinRate: "Win Rate",
    tabProfit: "Profit",
    experts: {
      trendCatcher: "Trend Catcher",
      whaleWatcher: "Whale Watcher",
      cryptoWolf: "Crypto Wolf",
      swingCaptain: "Swing Captain",
      arbHunter: "Arb Hunter",
      bullKnight: "Bull Knight"
    },
    tagPolitics: "Politics",
    tagEsports: "Esports",
    comingSoon: "Coming soon"
  },
  operationManual: {
    title: "Operation Manual",
    docTitle: "PANTA MARKET Operation Manual",
    sourceHint: "Illustrated steps adapted from the official manual. Tap screenshots to zoom."
  },
  pantaMarket: {
    title: "Panta Market",
    tokenSection: "Token de gobernanza PANTA",
    todayBurn: "Quemado hoy",
    totalBurn: "Total quemado",
    burned: "Quemado",
    initialSupply: "Emisión inicial",
    maxSupply: "Emisión máxima",
    finalCirculation: "Circulación final",
    contractAddress: "Contrato: ",
    copied: "Copiado",
    ecoSection: "PANTA · Ecosistema AI",
    ecoTabs: {
      market: "Análisis de mercado",
      arbitrage: "Herramientas de arbitraje",
      acquisition: "Adquisición global",
      video: "Creación de video"
    },
    apps: {
      pantaAi: "Panta AI",
      asiStar: "ASI Star",
      tatianaTv: "Tatiana TV",
      tokenSpace: "Token space"
    },
    groupSection: "PANTA · Grupos creativos",
    groupTabs: {
      recommend: "Para ti",
      hot: "Popular",
      ipDrama: "Drama IP",
      ipCollab: "Co-creación IP",
      data: "Datos"
    },
    filters: {
      all: "Todos",
      new: "Novedades",
      ending: "Por terminar",
      highScore: "Alta puntuación AI"
    },
    project: {
      badge: "Estreno en Planet",
      title: "《Panta AI · Ascenso》 Cortometraje animado de IA",
      score: "Puntuación AI 92",
      tagDrama: "Drama IP",
      tagRights: "Derechos #0001",
      desc: "Panta AI me ayuda a dar la vuelta — corto tutorial de apps AI"
    },
    values: {
      todayBurn: "321",
      totalBurn: "4.212",
      initialSupply: "10M",
      maxSupply: "210M",
      finalCirculation: "21M"
    }
  },
  copyTrade: {
    menuTitle: "Copia de trading",
    pageTitle: "Copia de trading",
    fallback: "La operación falló. Inténtelo de nuevo más tarde.",
    pauseRule: "Si sigue en pausa cuando se complete la liquidación de esta semana, la relación de copia se cancelará automáticamente la próxima semana.",
    pauseSuccess: "Pausado correctamente",
    resumeSuccess: "Reanudado",
    endSuccess: "Finalizado",
    followSuccess: "Copia iniciada",
    pendingReviewToast: "Pendiente de revisión del trader",
    savedSuccess: "Guardado",
    registerSuccess: "Registrado. Depósito congelado.",
    cancelRequested: "Cancelación solicitada",
    cancelWithdrawn: "Cancelación retirada",
    kickedSuccess: "Eliminado",
    approvedSuccess: "Aprobado",
    rejectedSuccess: "Rechazado",
    filledToForm: "Rellenado en el formulario de seguimiento",
    traderNotFound: {
      search: "Trader no encontrado. Compruebe la dirección de la wallet o es posible que aún no haya activado el copy trading.",
      business: "Este trader no está disponible actualmente"
    },
    tabs: {
      board: "Clasificación",
      follows: "Mis seguimientos",
      join: "Seguir",
      trader: "Liderar",
      apps: "Solicitudes",
      fans: "Seguidores",
      rules: "Reglas",
      settings: "Reglas",
      follow: "Seguir"
    },
    ui: {
      refresh: "Actualizar",
      search: "Buscar",
      loginWallet: "Conectar wallet",
      needLoginAction: "Esta acción requiere iniciar sesión con la wallet, igual que al hacer pedidos.",
      needLoginTrader: "Las API de trader requieren inicio de sesión.",
      loginToView: "Inicie sesión para ver",
      loading: "Cargando…",
      empty: "Ninguno",
      readonly: "solo lectura",
      yes: "Sí",
      no: "No",
      immediate: "efectivo de inmediato",
      current: "Actual",
      nextWeek: "Próxima semana",
      pause: "Pausar",
      resume: "Reanudar",
      end: "Finalizar",
      save: "Guardar",
      kick: "Eliminar",
      approve: "Aprobar",
      reject: "Rechazar",
      requestCancel: "Solicitar cancelación",
      withdrawCancel: "Retirar cancelación",
      confirmFollow: "Confirmar seguimiento",
      registerWithDeposit: "Congelar depósito y registrarse",
      registerConfirmTitle: "Confirmar registro",
      registerFreezeConfirm: "Se congelarán {amount} JOULE de margen en la cuenta de trading.",
      platformSettings: "Configuración de la plataforma",
      settingsTip: "Solo se copian las órdenes ordinarias aseguradas. Las órdenes ordinarias sin seguro y las órdenes AI no se copian, y las órdenes COPY generadas no generan más copias. Los traders usan la API de órdenes existente y no deben pasar orderSource. Los seguidores ven las órdenes COPY en la lista. Los importes muestran 2 decimales; el resto se trunca.",
      deposit: "Depósito",
      depositFreezeWeeks: "Semanas de congelación del depósito",
      maxFollowers: "Límite de seguidores",
      shareRateRange: "Rango de tasa de reparto",
      shareRateDefault: "Tasa de reparto predeterminada",
      shareRateNextWeek: "La tasa de reparto aplica la próxima semana",
      pendingShareHint: "Vigente el próximo lunes: {rate}",
      pendingMaxFollowersHint: "Vigente el próximo lunes: {n}",
      depositFrozenShort: "Aún congelado",
      minFollowStake: "Apuesta mínima de seguimiento",
      ratioRange: "Rango de ratio",
      maxSimultaneousFollows: "Máximo de seguimientos simultáneos",
      defaultReview: "Revisión predeterminada",
      defaultMinBalance: "Umbral de saldo predeterminado",
      settlementTimezone: "Zona horaria de liquidación",
      leaderboardMeta: "Mín. clasificación / tamaño",
      leaderboardMetaValue: "{min} órdenes / {size} filas",
      weekLeaderboard: "Clasificación de tasa de acierto de esta semana",
      expertLeaderboard: "Clasificación de traders",
      heroTitle: "Conviértase en trader líder",
      heroDesc: "Empiece a liderar operaciones y gane reparto de beneficios",
      heroActiveTitle: "Es trader líder",
      heroActiveDesc: "Su estado de trader líder está activo",
      heroRegister: "Registrarse",
      heroSettings: "Configuración de liderazgo",
      myLeading: "Mi liderazgo",
      winRateBoard: "Tasa de acierto",
      pnlBoard: "Beneficio",
      searchAddress: "Buscar dirección",
      searchNicknameOrAddress: "Buscar apodo o dirección",
      searchQueryTooShort: "Introduce al menos 2 caracteres",
      winRateShort: "Tasa de acierto",
      followersLabel: "Seguidores:",
      shareRateLabel: "Tasa de reparto:",
      roundPnlLabel: "PyG de la ronda:",
      settledOrders: "{n} liquidadas",
      activeCount: "En curso",
      followStatsShort: "Pool {pool} · Retenido {cash}",
      traderSettings: "Configuración de liderazgo",
      confirmChanges: "Confirmar cambios",
      confirmCancel: "Confirmar cancelación",
      cancelModalTitle: "Aviso de cancelación",
      activeInProgress: "En curso",
      leadingFollowerCount: "Seguidores {n}",
      auditApps: "Solicitudes {n}",
      leaderboardNote: "Solo cuenta las órdenes ordinarias aseguradas ganadas/perdidas liquidadas de esta semana, tras el mínimo de órdenes. No es la tasa histórica ni la de AI. No se proporcionan nombre de equipo ni volumen acumulado de seguimiento.",
      weekStart: "Inicio de semana (lun.): {date}",
      leaderboardEmpty: "Aún no hay traders en la clasificación. Busque la dirección completa para seguir.",
      winRate: "Acierto {n}%",
      boardSub: "Reparto {share} · Seguidores {followers}/{max} · Liquidadas {orders} · PyG semanal {pnl} JOULE",
      searchTrader: "Buscar trader",
      walletPlaceholder: "Dirección completa de wallet 0x…",
      address: "Dirección",
      status: "Estado",
      shareRate: "Tasa de reparto",
      review: "Revisión",
      minBalance: "Umbral de saldo",
      followerCount: "Seguidores",
      startFollow: "Empezar a seguir",
      traderWallet: "Dirección del trader",
      followMode: "Modo de seguimiento",
      ratioLabel: "Ratio (%), rango {min} ~ {max}",
      insuranceMode: "Modo de seguro",
      takeProfit: "Take profit (JOULE, opcional)",
      stopLoss: "Stop loss (JOULE, opcional)",
      takeProfitPh: "Pausar cuando el PyG neto semanal alcance esto",
      stopLossPh: "Pausar cuando la pérdida neta semanal alcance esto",
      followHint: "Puede seguir como máximo {n} trader(s) a la vez. Al llegar al límite, seguir a uno nuevo termina primero la relación actual — no es una vista previa sin efecto. Para cambiar parámetros, finalice y vuelva a seguir.",
      endConfirm:
        "¿Finalizar la relación de copy trading con este trader? Dejará de seguir sus señales. Las órdenes históricas y el PnL liquidado no se ven afectados.",
      weeklyPoolHint: "El pool es el de esta semana, no el volumen acumulado de seguimiento. Las relaciones finalizadas y solicitudes pendientes no están en esta lista.",
      networkUnclear: "Resultado no confirmado. Actualice y compruebe la relación actual o el perfil del trader antes de reintentar.",
      myFollows: "Mis seguimientos",
      noFollows: "Sin relaciones de seguimiento",
      followSub: "{mode}{ratio} · {insurance} · Reparto bloqueado {share}",
      followStats: "PyG semanal {pnl} · Pool {pool} · Retenido {cash}",
      pauseReason: "Motivo de pausa: {reason}",
      registerTrader: "Registrarse como trader",
      registerHint: "Registro: pague {amount} JOULE como depósito de trader líder (congelado mientras esté activo; reembolsado tras la revisión de cancelación). Una identidad de trader por wallet.",
      registerBalanceHint: "Tras congelar el depósito de {deposit} JOULE, el saldo disponible debe seguir siendo ≥ {remain} JOULE.",
      shareRateInput: "Tasa de reparto (%) rango {min} ~ {max}; los cambios aplican en el próximo ciclo.",
      maxFollowersInput: "Límite de seguidores (≤ {max})",
      reviewMode: "Método de aprobación",
      minBalanceInput: "Umbral de saldo del seguidor · opcional (JOULE)",
      myTrader: "Mi perfil de trader",
      depositHeld: "{amount} / congelado {held}",
      currentFollowers: "Seguidores actuales",
      cancelEffective: "Cancelación efectiva el",
      depositRelease: "Liberación del depósito el",
      editParams: "Editar configuración",
      editHint: "Reparto / límite aplican la próxima semana; revisión y umbral aplican de inmediato. El bloqueo de liquidación es dom. 22:00 hasta antes del lun. 01:00 (SGT). Confíe en el servidor; no reanude ediciones el lun. 00:00 por su cuenta.",
      shareRatePercent: "Tasa de reparto (%)",
      minBalanceJoule: "Umbral de saldo (JOULE)",
      cancelTip: "Tras la cancelación sigue liderando esta semana; la identidad termina el próximo lunes 00:00; el depósito permanece congelado una semana más y luego se devuelve. Puede retirar la solicitud antes de que surta efecto.",
      followers: "Seguidores",
      followerSub: "{mode}{ratio} · PyG semanal {pnl} · Retenido {cash}",
      applications: "Solicitudes pendientes",
      noApplications: "Sin solicitudes",
      fillForm: "Rellenar formulario de seguimiento",
      needTraderFirst: "Regístrese primero como trader",
      cancelRequestedAt: "Cancelación solicitada el",
      ratioRangeInvalid: "El ratio debe estar entre {min} y {max}",
      shareRangeInvalid: "La tasa de reparto debe estar entre {min} y {max}",
      maxFollowersInvalid: "El límite de seguidores no puede superar {max}",
      needShareRate: "Introduzca una tasa de reparto",
      needMaxFollowers: "Introduzca un límite de seguidores",
      needRatio: "Introduzca un ratio",
      badTakeProfit: "Importe de take profit no válido",
      badStopLoss: "Importe de stop loss no válido",
      badMinBalance: "Umbral de saldo no válido",
      insuranceShortFollow: "Seguir",
      insuranceShortOn: "Siempre activo",
      insuranceShortOff: "Siempre inactivo",
      symbolSettings: "Configuración de símbolos de copia",
      symbolPickHint: "todo desactivado por defecto; active manualmente, editable en cualquier momento",
      followSymbolHint: "Elija entre los símbolos permitidos por este trader. Active al menos uno.",
      followSymbolWait: "Busque primero un trader y luego elija los símbolos a seguir.",
      symbolNeedOne: "Active al menos un símbolo",
      symbolNotAllowed: "Un símbolo seleccionado no está permitido por este trader",
      effectiveSymbols: "Efectivos",
      editSymbols: "Editar símbolos",
      allowedSymbols: "Símbolos abiertos",
      weekPnlLabel: "PyG de la semana:",
      currentNetPnlLabel: "Current Net PnL",
      categoryCrypto: "Cripto",
      categoryCommodity: "Materias primas",
      categoryEquity: "Acciones",
      symbolListCol: "Lista",
      symbolLeadCol: "Liderar",
      symbolFollowCol: "Seguir",
      symbolTags: "Abierto",
      leadingSymbols: "Símbolos liderados",
      detail: "Detalles",
      enabled: "Activado",
      disabled: "Desactivado",
      held: "Abierto",
      notHeld: "Cerrado",
      weekSettledOrders: "Liquidadas esta semana",
      historicalNetPnl: "PyG histórico",
      copyTotalPnl: "PnL total copy",
      historicalSharePayout: "Repartos pagados",
      allOrders: "Todas",
      prevPage: "Prev",
      nextPage: "Next",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Go to",
      jumpConfirm: "Go",
      openOrders: "Abiertas",
      settledOrdersTab: "Liquidadas",
      colInterval: "Duración",
      colOrderTime: "Hora de la orden",
      colSelfPnl: "PyG propio (c/ prima)",
      colEstShare: "Reparto est. (JOULE)",
      traderOrdersTitle: "Órdenes líder de {symbol}",
      followOrdersTitle: "Órdenes de copia de {symbol}",
      selfPnl: "PyG propio",
      estimatedShare: "Reparto est.",
      inProgress: "En curso",
      followAssets: "PyG por activo",
      byAsset: "Por activo",
      followHistory: "Finalizadas",
      followStartTime: "Inicio: ",
      followEndTime: "Fin: ",
      myPendingApps: "Pendientes",
      cashHeldHint: "Reparto est. retenido esta semana {cash} JOULE",
      cashHeldFrozen: "Deducción est. de reparto esta ronda: {cash} (JOULE, congelado)",
      followedTrader: "Trader",
      followInfo: "Info de seguimiento",
      totalPnlJoule: "PyG total (JOULE)",
      colTrader: "Trader",
      colPrincipal: "Principal",
      colPnlShare: "PyG (c/ prima) / reparto (JOULE)",
      traderInfo: "Perfil del trader",
      traderNotFound: "Trader no encontrado",
      followSettingsRelationHint: "El modo de follow, el seguro y el TP/SL aplican a toda la relación y a todos los símbolos seleccionados. Puedes cambiarlos en Ajustes de follow.",
      followSettingsPrepareHint: "Al confirmar, se usará esta configuración en todos los símbolos que actives.",
      followOptions: "Opciones de seguimiento",
      noFollowOptions: "Sin opciones de seguimiento~",
      symbolFollowing: "Siguiendo",
      symbolPaused: "Pausado",
      symbolIdle: "Sin seguir",
      cancelFollowSymbol: "Dejar de seguir",
      cancelSymbolConfirm: "¿Dejar de seguir {symbol}?",
      cancelLastSymbolConfirm: "Este es el último símbolo. Dejar de seguir terminará toda la relación. ¿Continuar?",
      followNow: "Seguir ahora",
      followAll: "Seguir",
      unfollowAll: "Dejar de seguir",
      unfollowAllConfirm: "¿Dejar de seguir todos los símbolos de este trader? Esto terminará toda la relación de copia.",
      followSettings: "Ajustes",
      goFollowSettings: "Abrir ›",
      copyAccountBalance: "Cuenta copy: {amount} JOULE",
      orderFollowerCount: "Seguidores en esta orden",
      copyingStatus: "Copiando",
      roleStatusLeading: "Liderando",
      roleStatusFollowing: "Copiando",
      roleStatusPaused: "Copia pausada",
      copyOrderTag: "Copy",
      copyOpenPositions: "Posiciones copy abiertas",
      copyInsuredOrdinary: "Seguro ordinario activo",
      copyUninsured: "Sin seguro",
      addSymbolHint: "Este símbolo se añadirá a su seguimiento actual.",
      myRelationStatus: "Mi seguimiento",
      latestSettlements: "Últimas liquidaciones",
      resumeRelationFirst: "La relación está totalmente pausada. Reanúdela en Mis seguimientos antes de acciones por símbolo.",
      resumeStopLossHint: "Current weekly loss is {amount}. Set stop-loss above {amount} to resume copying.",
      resumeTakeProfitHint: "Current weekly profit is {amount}. Set take-profit above {amount} to resume copying.",
      resumeStartFollow: "Start following",
      colType: "Tipo",
      colPnlJoule: "PyG (JOULE)",
      tpSl: "Take profit / stop loss",
      takeProfitPhFull: "Pausar tras alcanzar beneficio neto semanal — opcional (JOULE)",
      stopLossPhFull: "Pausar tras alcanzar pérdida neta semanal — opcional (JOULE)",
      confirmModify: "Confirmar",
      clearSearch: "Volver a la clasificación",
      searchResultHint: "Resultados de búsqueda (toque para abrir el perfil del trader)",
      searchEmpty: "Trader no encontrado",
      noMoreSettlements: "No hay más"
    },
    errors: {
      AUTH_REQUIRED: "Conecte primero su wallet",
      AUTH_UNAVAILABLE: "El servicio de inicio de sesión no está disponible temporalmente. Inténtelo más tarde.",
      POSTGRES_REQUIRED: "Servicio temporalmente no disponible. Inténtelo más tarde.",
      USER_NOT_FOUND: "Usuario no encontrado. Inicie sesión de nuevo e inténtelo otra vez.",
      INVALID_WALLET: "Introduzca una dirección de wallet completa",
      INVALID_QUERY: "Consulta inválida; introduce al menos 2 caracteres",
      INVALID_AMOUNT: "Formato de importe no válido",
      INVALID_PARAM: "Parámetros no válidos. Compruebe e inténtelo de nuevo.",
      INVALID_FOLLOW: "No puede copiar sus propias operaciones",
      TRADER_EXISTS: "Esta wallet ya es trader. No hace falta registrarse de nuevo.",
      TRADER_FULL: "Este trader ha alcanzado el límite de seguidores",
      TRADER_CANCELLED: "Esta cuenta de trader ha sido cancelada",
      TRADER_REGISTER_FAILED: "Error al registrarse como trader. Inténtelo más tarde.",
      TRADER_SETTINGS_FAILED: "Error al guardar la configuración del trader. Inténtelo más tarde.",
      NOT_A_TRADER: "Register as a trader first",
      TRADER_UNAVAILABLE: "This trader is currently unavailable",
      INSUFFICIENT_BALANCE: "Saldo disponible insuficiente para congelar el depósito",
      BALANCE_TOO_LOW: "El saldo de la cuenta copy está por debajo del umbral de este trader. Transfiere desde la cuenta de trading primero",
      COPY_BALANCE_ZERO: "El saldo de la cuenta copy es 0. Transfiere desde la cuenta de trading primero",
      INSUFFICIENT_FUNDS: "Saldo de la cuenta de trading insuficiente para transferir a la cuenta copy",
      COPY_TRADE_BALANCE_INSUFFICIENT: "Saldo disponible de la cuenta copy insuficiente (el stake/share congelado no se puede retirar)",
      ACCOUNT_NOT_FOUND: "Error de cuenta. Inténtelo más tarde.",
      ACCOUNT_CONFLICT: "La cuenta se está actualizando. Inténtelo más tarde.",
      FOLLOW_EXISTS: "Ya sigue a este trader",
      FOLLOW_LIMIT: "Ya tiene una relación de copia activa. Finalícela antes de seguir a otro trader.",
      FOLLOW_FAILED: "Error al iniciar la copia. Inténtelo más tarde.",
      FOLLOW_NOT_FOUND: "Relación de copia no encontrada",
      PAUSE_FAILED: "Error al pausar la copia. Inténtelo más tarde.",
      RESUME_FAILED: "Error al reanudar la copia. Inténtelo más tarde.",
      STOP_LOSS_THRESHOLD: "Stop-loss is still too low. Raise or clear it, then resume.",
      TAKE_PROFIT_THRESHOLD: "Take-profit is still too low. Raise or clear it, then resume.",
      END_FAILED: "Error al finalizar la copia. Inténtelo más tarde.",
      APPLICATION_NOT_FOUND: "Solicitud pendiente no encontrada",
      APPROVE_FAILED: "Error al aprobar la solicitud. Inténtelo más tarde.",
      REJECT_FAILED: "Error al rechazar la solicitud. Inténtelo más tarde.",
      KICK_FAILED: "Error al eliminar al seguidor. Inténtelo más tarde.",
      SETTLEMENT_WINDOW: "No se puede cambiar la configuración del trader durante la ventana de liquidación",
      CANCEL_FAILED: "Error al solicitar la cancelación. Inténtelo más tarde.",
      CANCEL_NOT_PENDING: "No hay solicitud de cancelación que retirar",
      CANCEL_WITHDRAW_FAILED: "Error al retirar la cancelación. Inténtelo más tarde.",
      COPY_SETTINGS_MISSING: "La configuración de copy trading no está lista. Inténtelo más tarde.",
      INVALID_SYMBOL: "Seleccione al menos un símbolo compatible",
      SYMBOL_NOT_ALLOWED: "Incluye un símbolo que este trader no permite",
      TRADER_BALANCE_TOO_LOW: "El saldo disponible tras congelar el depósito es demasiado bajo para registrarse",
      TIMEOUT: "La operación falló. Inténtelo más tarde.",
      NETWORK: "La operación falló. Inténtelo más tarde."
    },
    status: {
      ACTIVE: "Activo",
      PAUSED: "Pausado",
      ENDED: "Finalizado",
      PENDING_REVIEW: "Pendiente de revisión del trader",
      CANCEL_PENDING: "Cancelación pendiente",
      CANCELLED: "Cancelado"
    },
    traderStatus: {
      ACTIVE: "Liderando",
      CANCEL_PENDING: "Saliendo",
      CANCELLED: "Cancelado",
    },
    pauseReason: {
      USER: "Pausado por el usuario",
      INSUFFICIENT_BALANCE: "Pausado: saldo de la cuenta copy insuficiente",
      TAKE_PROFIT: "Take profit activado",
      STOP_LOSS: "Stop loss activado",
      TRADER_KICK: "Eliminado por el trader",
      SWITCH: "Trader cambiado",
      SETTLEMENT_CLEANUP: "Eliminado en la liquidación semanal",
      TRADER_CANCEL: "Trader cancelado"
    },
    followMode: {
      EQUAL: "Importe igual",
      RATIO: "Ratio"
    },
    insuranceMode: {
      FOLLOW: "Seguir al trader",
      ALWAYS_ON: "Siempre activo",
      ALWAYS_OFF: "Siempre inactivo"
    },
    reviewMode: {
      AUTO: "Seguimiento automático",
      MANUAL: "Seguimiento con revisión"
    },
    applicationStatus: {
      PENDING: "Pendiente",
      APPROVED: "Aprobado",
      REJECTED: "Rechazado",
      CANCELLED: "Cancelado",
      PENDING_REVIEW: "Pendiente"
    }
  },}
